// Restaurants
// Bars
// Bookstores
// Coffee / Tea / Boba Shops
// Markets
// Movie Theaters
// Music Venues
// Parks
// Photo Opp
// Attractions (nrg, toyota, kemah)

import badges from "./badges";
import neighborhoodBlurbs from "./neighborhoods";

const locations = [
    // Restaurants
    {
        name: 'Wannabao',
        category: 'food',
        subcategory: ['dumplings', 'soup'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.747720290049234, -95.38028603278978],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/yzjy5Ek.png',
        website: 'https://wannabao.com/',
        blurb: 'Contemporary, industrial interiors & a menu of Chinese classic dishes, served family-style.',
        description: ['Delicious dumplings', 'Delicious tea', 'Crispy bottom bao']
    },
    {
        name: 'Taste of Korea',
        category: 'food',
        subcategory: ['ricebowl', 'soup'],
        badges: ['NFC mobile payments', 'vegetarian options'],
        coordinates: [29.997460350283827, -95.19376149496405],
        neighborhood: 'Atascocita',
        img: 'https://i.imgur.com/vixRkWH.png',
        website: 'https://www.google.com/search?q=taste+of+korea+houston+restaurant&client=opera-gx&hs=1xJ&sca_esv=4aa7399608798402&sxsrf=AHTn8zptgKriNcwjnfSJFGJA5pfFsredLw%3A1745096166437&ei=5g0EaPy7Gta4wN4PuMiVsAc&ved=0ahUKEwj8xuXo_eSMAxVWHNAFHThkBXYQ4dUDCBI&uact=5&oq=taste+of+korea+houston+restaurant&gs_lp=Egxnd3Mtd2l6LXNlcnAiIXRhc3RlIG9mIGtvcmVhIGhvdXN0b24gcmVzdGF1cmFudDIFECEYoAEyBRAhGKABMgUQIRigATIFECEYoAEyBRAhGKABMgUQIRirAkiBLFCrBViYK3AIeAGQAQCYAacBoAH6DKoBBDE0LjO4AQPIAQD4AQGYAhmgAuENwgIKEAAYsAMY1gQYR8ICDRAAGLADGNYEGEcYyQPCAg4QABiABBiwAxiSAxiKBcICChAjGIAEGCcYigXCAgsQLhiABBjHARivAcICBhAAGBYYHsICAhAmwgILEAAYgAQYhgMYigXCAggQABiABBiiBMICBRAAGO8FwgIaEC4YgAQYxwEYrwEYlwUY3AQY3gQY4ATYAQHCAgUQABiABMICEBAuGIAEGBQYhwIYxwEYrwHCAhAQLhiABBhDGMcBGIoFGK8BwgIIEAAYgAQYyQPCAgUQIRifBZgDAIgGAZAGCboGBggBEAEYFJIHBDIxLjSgB9iXAbIHBDEzLjS4B8UN&sclient=gws-wiz-serp',
        blurb: 'Casual resource for Korean starters, soups & BBQ plus tempura, wings, shaved ice & mochi.',
        description: ['Friendly owner', 'Hot stone bowl', 'Unreliable hours']
    },
    {
        name: 'Xiaolong Dumpling',
        category: 'food',
        subcategory: ['dumplings', 'soup'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.751968194944496, -95.385205425497],
        neighborhood: 'Fourth Ward',
        img: 'https://i.imgur.com/mL0K4FI.png',
        website: 'https://pos.chowbus.com/online-ordering/store/Xiaolong-Dumpling/14867',
        blurb: 'Opened in 2024, this cozy eatery serves handmade dumplings alongside fiery Sichuan dishes.',
        description: ['Friendly staff', 'Soup dumplings', 'Garlic cucumbers']
    },
    {
        name: 'Mensho',
        category: 'food',
        subcategory: ['ramen', 'upscale', 'soup'],
        badges: ['michelin rated', 'NFC mobile payments', 'vegetarian options'],
        coordinates: [29.702776279471518, -95.55277518132357],
        neighborhood: 'Chinatown',
        img: 'https://i.imgur.com/vi8bS5Z.png',
        website: 'https://mensho.com/',
        blurb: 'Creative ramen specialty store',
        description: ['Michelin recommended', 'Expect a wait', 'Garlic Knock Out']
    },
    {
        name: 'Blue Sushi',
        category: 'food',
        subcategory: ['sushi', 'soup'],
        badges: ['outdoor seating', 'NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.782854094917795, -95.40735213529982],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/TI5ybqr.png',
        website: 'https://www.bluesushisakegrill.com/locations/m-k-t-heights',
        blurb: 'Modern, clubby restaurant featuring sushi & Japanese tapas, plus fancy mixed drinks.',
        description: ['Sushi rolls', 'Sake', 'Godzilla Bomb']
    },
    {
        name: 'The Taco Stand',
        category: 'food',
        subcategory: ['tacos', 'breakfast', 'salads'],
        badges: ['drive thru', 'open late', 'NFC mobile payments', 'vegetarian options'],
        coordinates: [29.804581677923732, -95.40996772397978],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/iCIE0bY.png',
        website: 'https://tacostandhtx.com/',
        blurb: 'Casual, modern taco specialist using housemade tortillas, also offering drinks & an all-day menu.',
        description: ['Breakfast tacos', 'Brisket & egg', 'Chorizo & egg']
    },
    {
        name: 'Insomnia Cookies',
        category: 'food',
        subcategory: ['dessert'],
        badges: ['open late'],
        coordinates: [29.717783381639077, -95.41698820235376],
        neighborhood: 'Rice Village',
        img: 'https://i.imgur.com/0cyEvM4.png',
        website: 'https://insomniacookies.com/',
        blurb: 'Bakery chain known for warm cookies, ice cream & late-night deliveries.',
        description: ['Open late', 'Deluxe cookies', 'Ice cream']         
    },
    {
        name: 'The Rice Box',
        category: 'food',
        subcategory: ['ricebowl', 'soup'],
        badges: ['open late', 'NFC mobile payments'],
        coordinates: [29.80367761668916, -95.40176409739686],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/fBLTpv2.png',
        website: 'https://i.imgur.com/fBLTpv2.png',
        blurb: "Hip outpost offering reinvented Chinese classics such as kung pao chicken and General Tso's chicken.",
        description: ['Open late', 'Kung pao beef', 'Chow fun']
    },
    {
        name: 'The Rice Box',
        category: 'food',
        subcategory: ['ricebowl', 'soup'],
        badges: ['open late', 'NFC mobile payments', 'outdoor seating', 'vegetarian options'],
        coordinates: [29.71659805044453, -95.41461404468372],
        neighborhood: 'Rice Village',
        img: 'https://i.imgur.com/kac6XNX.png',
        website: 'https://i.imgur.com/fBLTpv2.png',
        blurb: "Hip outpost offering reinvented Chinese classics such as kung pao chicken and General Tso's chicken.",
        description: ['Open late', 'Kung pao beef', 'Chow fun']
    },
    {
        name: "The Monk's - Humble",
        category: 'food',
        subcategory: ['ricebowl', 'soup'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [30.003620305655076, -95.27773996608327],
        neighborhood: 'Deerbrook',
        img: 'https://i.imgur.com/X6qqegt.png',
        website: 'https://www.monkshumble.com/',
        blurb: 'Indian and Chinese cooking, including vegetarian options, served in a casual space with counter and table service.',
        description: ['Indian', 'Very spicy', 'Samosas']
    },
    {
        name: "Pepperoni's Pizza",
        category: 'food',
        subcategory: ['pizza'],
        badges: ['drive thru', 'open late', 'NFC mobile payments', 'vegetarian options'],
        coordinates: [29.745293850102062, -95.39171676019866],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/Dl2FSsJ.png',
        website: 'https://www.pepperonis.net',
        blurb: 'Casual pizzeria chain serving wings & New York-style pies, including vegan & gluten-free options.',
        description: ['open late', 'pizza by the slice', 'drive thru']
    },
    {
        name: "Nielson's Delicatessen",
        category: 'food',
        subcategory: ['sandwiches', 'soup'],
        badges: ['NFC mobile payments'],
        coordinates: [29.733001745772487, -95.45125833534226],
        neighborhood: 'River Oaks',
        img: 'https://i.imgur.com/2j3MCnc.png',
        website: 'https://www.nielsensdelicatessen.com/',
        blurb: 'Breakfast & lunch spot doling out old-school deli fare including sandwiches & popular potato salad.',
        description: ['historic', 'daily soups', 'quality deli meat']
    },
    {
        name: "Portillo's",
        category: 'food',
        subcategory: ['hotdogs', 'hamburgers', 'sandwiches'],
        badges: ['drive thru', 'open late', 'NFC mobile payments'],
        coordinates: [29.964633753145392, -95.54078033344278],
        neighborhood: 'Willowbrook',  
        img: 'https://i.imgur.com/zGO20pT.png',
        website: 'https://www.portillos.com/index.html',
        blurb: 'Chicago-born chain for hot dogs, Italian beef sandwiches & more, plus beer & wine, in retro digs.',
        description: ['Chicago Favorite', 'Original Beef', 'Chicago Hotdog']
    },
    {
        name: 'In & Out',
        category: 'food',
        subcategory: ['burgers'],
        badges: ['drive thru', 'open late', 'NFC mobile payments'],
        coordinates: [29.963688061809677, -95.5421339703664],
        neighborhood: 'Willowbrook',  
        img: 'https://i.imgur.com/U7f9s2M.png',
        website: 'www.in-n-out.com/',
        blurb: 'Classic burger chain serving customizable burgers, hand-cut fries & shakes.',
        description: ['California Favorite', 'Flying Dutchman w/ Onions', 'Flying Ducthman w/ Tomatoes']
    },
    {
        name: 'Cheba Hut',
        category: 'food',
        subcategory: ['sandwiches'],
        badges: ['open late', 'NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.77234244004, -95.37822662667772],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/ThKWsLq.png',
        website: 'https://chebahut.com/locations/houston-sawyer-yards/',
        blurb: 'Laid-back sandwich-shop chain for creative toasted subs, plus snacks & desserts.',
        description: ["'Toasted' Subs", 'Open Late', 'Stoner Themed']
    },
    {
        name: 'Blodgett Hall',
        category: 'food',
        subcategory: ['hall'],
        badges: ['open late', 'NFC mobile payments', 'outdoor seating', 'vegetarian options'],
        coordinates: [29.722847269152375, -95.37002136428438],
        neighborhood: 'South Side',
        img: 'https://i.imgur.com/4CSW5F3.png',
        website: '',
        blurb: 'Food hall with multiple kitchens dishing up global fare, including vegan options.',
        description: ['Food Hall', 'Open Late', 'BYOB']
    },
    {
        name: 'Homeslice',
        category: 'food',
        subcategory: ['pizza', 'sandwiches'],
        badges: ['paid parking', 'outdoor seating', 'alcohol available'],
        coordinates: [29.738749524090423, -95.38015318985526],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/8UP0hfL.png',
        website: 'https://homeslicepizza.com/location/houston-midtown/',
        blurb: 'Casual pizzeria serving New York-style and Sicilian pies plus subs, beer, and wine.',
        description: ['Austin Favorite', 'Pizza by the Slice', 'Italian Subs']
    },
    {
        name: 'Breakfast Klub',
        category: 'food',
        subcategory: ['breakfast'],
        badges: ['black owned', 'paid parking', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.73848124453339, -95.38038932724314],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/Vhk1SH7.png',
        website: 'https://thebreakfastklub.com',
        blurb: 'Hotspot for diner-style American eats & stick-to-your-ribs soul food including chicken & waffles.',
        description: ['Open Early', 'Expect a wait', 'Chicken and Waffles']
    },
    {
        name: 'Iekei',
        category: 'food',
        subcategory: ['sushi', 'ramen', 'soup'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.935672247210096, -95.25000159496145],
        neighborhood: 'Humble',
        img: 'https://i.imgur.com/DeH0uJX.png',
        website: 'https://www.humbleiekei.com',
        blurb: 'Casual Japanese restaurant offering sushi and small plates including ramen and sake.',
        description: ['Sushi', 'Hand Rolls', 'Ramen']
    },    
    {
        name: "Frank's Pizza",
        category: 'food',
        subcategory: ['pizza'],
        badges: ['open late', 'vegetarian options', 'alcohol available'],
        coordinates: [29.761548417674607, -95.36217053914736],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/r9WxDCJ.png',
        website: 'https://www.frankspizza.com',
        blurb: 'Giant, foldable slices of New York-style thin crust pizza (or whole pies) available late night.',
        description: ['Historic', 'Pizza by the Slice', 'Open Late']
    },
    {
        name: "Tacos Aracely's",
        category: 'food',
        subcategory: ['tacos', 'breakfast'],
        coordinates: [29.840820719855106, -95.35421491888364],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/uOPHIrD.png',
        website: 'https://tacosaracelys.shop',
        blurb: 'Casual Mexican stand serving traditional comfort food such as barbacoa, gorditas, and breakfast tacos.',
        description: ['Delicious Tacos', 'Open Early', 'Mexican Potato w/ Sausage']
    },
    {
        name: "Frenchy's",
        category: 'food',
        subcategory: ['chicken'],
        badges: ['black owned', 'drive thru', 'open late'],
        coordinates: [29.723491931484464, -95.35128034035448],
        neighborhood: 'South Side',
        img: 'https://i.imgur.com/6U88NCq.png',
        website: 'https://frenchyschicken.com',
        blurb: 'Fast-food chain serving fried chicken, gumbo, jambalaya & other classic Creole dishes.',
        description: ['Houston Favorite', 'Best Fried Chicken', 'Jalapenos']
    },
    {
        name: 'La Guadalupana',
        category: 'food',
        subcategory: ['tacos', 'breakfast', 'burritos'],
        badges: ['NFC mobile payments', 'vegetarian options'],
        coordinates: [29.75397083325556, -95.38335480760226],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/vqse05w.png',
        website: 'https://www.laguadalupanacafeandbakery.com',
        blurb: 'Family-run eatery featuring sweet & savory baked goods & Mexican breakfasts in cozy, no-frills digs.',
        description: ['Breakfast tacos', 'Coffee', 'Bakery']
    },
    {
        name: 'Velvet Taco',
        category: 'food',
        subcategory: ['tacos'],
        badges: ['NFC mobile payments', 'alcohol available', 'vegetarian options'],
        coordinates: [29.804085974827032, -95.41029345468208],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/YCP3F7w.png',
        website: 'https://www.velvettaco.com',
        blurb: 'Tacos with global-inspired fillings, plus margaritas and beer, in a trendy atmosphere.',
        description: ['Creative Menu', 'Backdoor Chicken', 'Elote']
    },
    {
        name: 'Velvet Taco',
        category: 'food',
        subcategory: ['tacos'],
        badges: ['NFC mobile payments', 'alcohol available', 'vegetarian options'],
        coordinates: [29.77027627032481, -95.41004657788817],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/hGeXyPH.png',
        website: 'https://www.velvettaco.com',
        blurb: 'Tacos with global-inspired fillings, plus margaritas and beer, in a trendy atmosphere.',
        description: ['Creative Menu', 'Backdoor Chicken', 'Elote']
    },
    {
        name: 'Velvet Taco',
        category: 'food',
        subcategory: ['tacos'],
        badges: ['NFC mobile payments', 'alcohol available', 'vegetarian options'],
        coordinates: [29.717317503095316, -95.41767773335643],
        neighborhood: 'Rice Village',
        img: 'https://i.imgur.com/h2egeXD.png',
        website: 'https://www.velvettaco.com',
        blurb: 'Tacos with global-inspired fillings, plus margaritas and beer, in a trendy atmosphere.',
        description: ['Creative Menu', 'Backdoor Chicken', 'Elote']
    },
    {
        name: 'Velvet Taco',
        category: 'food',
        subcategory: ['tacos'],
        badges: ['NFC mobile payments', 'alcohol available', 'vegetarian options'],
        coordinates: [29.744484475293824, -95.39052608843915],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/XJpCvG9.png',
        website: 'https://www.velvettaco.com',
        blurb: 'Tacos with global-inspired fillings, plus margaritas and beer, in a trendy atmosphere.',
        description: ['Creative Menu', 'Backdoor Chicken', 'Elote']
    },
    {
        name: 'Tacodeli',
        category: 'food',
        subcategory: ['tacos', 'breakfast', 'salads'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.76797814164908, -95.37732067077975],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/pA5cQfu.jpg',
        website: 'https://www.tacodeli.com',
        blurb: 'Austin-born outpost of a taqueria chain serving more than 40 taco types, including breakfast.',
        description: ['Austin Favorite', 'Salsa Bar', 'Grab N Go']
    },
    {
        name: 'Poppa Burger',
        category: 'food',
        subcategory: ['burgers'],
        badges: ['open late', 'outdoor seating', 'cash only'],
        coordinates: [29.774259091292073, -95.36036566574973],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/Cgsjnw4.png',
        website: 'https://www.facebook.com/people/POPPA-BURGER-INC/100057602081572/',
        blurb: 'Longstanding 24-hour burger stand with covered seating featuring American classics & tacos too.',
        description: ['Open Late', 'Cheap', 'Cash Only']
    },
    {
        name: 'Pluckers',
        category: 'food',
        subcategory: ['chicken'],
        badges: ['open late', 'outdoor seating', 'vegetarian options', 'alcohol available'],
        coordinates: [29.773607958972853, -95.40909531330995],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/M9FqFGx.png',
        website: 'https://www.pluckers.com/location/shepherd',
        blurb: 'Sports bar known for its chicken wings',
        description: ['Double fried wings', 'Fried Mozzarella', 'Request WNBA on TV']
    },
    {
        name: 'Iza Robata',
        category: 'food',
        subcategory: ['sushi', 'ramen', 'soup', 'poke'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [30.05598142350976, -95.57291198620665],
        neighborhood: 'Spring',
        img: 'https://i.imgur.com/NBFiFJo.jpg',
        website: 'https://izarobatatx.com',
        blurb: 'Japanese restaurant that serves authentic and creative Japenese cuisine',
        description: ['Sake bar', 'Hibachi', 'Poke']
    },
    {
        name: 'Pok Pok Po',
        category: 'food',
        subcategory: ['chicken'],
        badges: ['paid parking', 'vegetarian options'],
        coordinates: [29.742582523950063, -95.37996336798173],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/jtwveVK.png',
        website: 'https://www.pokpokpo.com',
        blurb: 'Fried chicken concept serving gluten free, antibiotic free, hormone free, halal chicken',
        description: ["'Indian Chick Fil A'", 'Halal & Gluten Free', 'Mango Lassi']
    },
    {
        name: 'Azteca Taco House',
        category: 'food',
        subcategory: ['tacos', 'breakfast'],
        coordinates: [29.879900615131934, -95.33001824192365],
        neighborhood: 'East Aldine',
        img: 'https://i.imgur.com/vOWNjpt.png',
        website: 'https://aztecatacohousetx.com',
        blurb: 'Casual eatery specializing in breakfast tacos, carne guisada, and homemade flour tortillas.',
        description: ['Texas Monthly Top 10 Tacos', 'Delicious Breakfast Tacos', 'Spanish Speaking Preferred']
    },
    {
        name: "Brother's Pizza Express",
        category: 'food',
        subcategory: ['pizza'],
        badges: ['NFC mobile payments', 'vegetarian options'],
        coordinates: [30.05201190215551, -95.43342391197649],
        neighborhood: 'Spring',
        img: 'https://i.imgur.com/ONoiyzI.png',
        website: 'https://brotherspizzeriahouston.com',
        blurb: 'Low-key pizzeria with New York-style pies whole or by the slice, plus calzones, pastas & sandwiches',
        description: ['Pizza by the Slice', 'Large Pizzas', 'Sub Sandwiches']
    },
    {
        name: "Brother's Pizza Express",
        category: 'food',
        subcategory: ['pizza'],
        badges: ['NFC mobile payments'],
        coordinates: [29.958437436159638, -95.56441467471862],
        neighborhood: 'Willowbrook',
        img: 'https://i.imgur.com/EaSTaIk.png',
        website: 'https://brotherspizzeriahouston.com',
        blurb: 'Mainstay for pizza & other casual Italian-inspired comfort food, including stromboli & calzones',
        description: ['Pizza by the Slice', 'Large Pizzas', 'Sub Sandwiches']
    },
    {
        name: "Yoyo's Hotdog - POST",
        category: 'food',
        subcategory: ['hotdogs'],
        badges: ['paid parking'],
        coordinates: [29.766272186344448, -95.36461056318291],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/Lz71WDl.png',
        website: 'https://www.instagram.com/yoyoshotdogshtx/?hl=en',
        blurb: 'Casual spot serving hot dogs and other quick bites for lunch.',
        description: ['Original Hotdog', 'Drinks', "That's It."]
    },
    {
        name: "Yoyo's Hotdog",
        category: 'food',
        subcategory: ['hotdogs'],
        badges: ['open late', 'paid parking'],
        coordinates: [29.749426924148914, -95.35545770557285],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/PQCIziO.png',
        website: 'https://www.instagram.com/yoyoshotdogshtx/?hl=en',
        blurb: 'Hot dog stand turning out quick bites in a casual atmosphere.',
        description: ['Original Hotdog', 'Drinks', "That's It."]
    },
    {
        name: "Yoyo's Hotdog",
        category: 'food',
        subcategory: ['hotdogs'],
        badges: ['open late', 'paid parking'],
        coordinates: [29.770734786401515, -95.40811760984687],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/IqsbBbr.png',
        website: 'https://www.instagram.com/yoyoshotdogshtx/?hl=en',
        blurb: 'Hot dog stand turning out quick bites in a casual atmosphere.',
        description: ['Original Hotdog', 'Drinks', "That's It."]
    },
    {
        name: 'Fogo de Chão',
        category: 'food',
        subcategory: ['upscale', 'steak', 'soup', 'salads'],
        badges: ['alcohol available'],
        coordinates: [29.738151249900074, -95.51179108918673],
        neighborhood: 'Mid West',
        img: 'https://i.imgur.com/e6B9RR1.png',
        website: 'https://fogodechao.com',
        blurb: "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
        description: ['Brazilian Steakhouse', 'Salad Bar', 'Sweet Plantains']
    },
    {
        name: 'Chama Gaúcha',
        category: 'food',
        subcategory: ['upscale', 'steak', 'soup', 'salads'],
        badges: ['alcohol available'],
        coordinates: [29.737575389908308, -95.48292126437322],
        neighborhood: 'Mid West',
        img: 'https://i.imgur.com/YTOriix.png',
        website: 'https://www.chamagaucha.com/houston',
        blurb: 'Upscale spot featuring all-you-can-eat tableside-carved Brazilian meat & a global wine list.',
        description: ['Brazilian Steakhouse', 'Salad Bar', 'Sweet Plantains']
    },
    {
        name: 'Zalat',
        category: 'food',
        subcategory: ['pizza'],
        badges: ['open late', 'NFC mobile payments'],
        coordinates: [29.803678071023104, -95.4010202575722],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/ooiiaUo.png',
        website: 'https://zalatpizza.com',
        blurb: 'Order handcrafted, unique-flavored pizzas for delivery or takeout. Open late to satisfy your cravings!',
        description: ['Creative Pizzas', 'Open Late', 'Walkable Area']
    },
    {
        name: 'Zalat',
        category: 'food',
        subcategory: ['pizza'],
        badges: ['open late', 'NFC mobile payments'],
        coordinates: [29.771050199341097, -95.40971992986691],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/mxTDr8B.png',
        website: 'https://zalatpizza.com',
        blurb: 'Order handcrafted, unique-flavored pizzas for delivery or takeout. Open late to satisfy your cravings!',
        description: ['Creative Pizzas', 'Open Late', 'Walkable Area']
    },
    {
        name: 'Butter Funk Kitchen',
        category: 'food',
        subcategory: ['chicken', 'seafood'],
        badges: ['black owned', 'alcohol available'],
        coordinates: [29.668880222117025, -95.36784422747914],
        neighborhood: 'South Side',
        img: 'https://i.imgur.com/5eNndPo.png',
        website: 'https://butterfunkhtx.com/',
        blurb: 'Casual place for Southern eats, such as fried ribs, plus daiquiris and other drinks.',
        description: ['Keith Lee approved', 'Daiquiris', 'Kool Aid']
    },
    {
        name: "Layne's Chicken Fingers",
        category: 'food',
        subcategory: ['chicken'],
        badges: ['drive thru', 'open late', 'NFC mobile payments'],
        coordinates: [29.81397761857514, -95.42886442694316],
        neighborhood: 'Oak Forest',
        img: 'https://i.imgur.com/cIiMWdH.png',
        website: 'https://www.layneschickenfingers.com',
        blurb: 'Chain restaurant specializing in its iconic chicken fingers, plus lemonade and Texas toast.',
        description: ['Chicken Fingers', 'Special Sauce', 'French Fries']
    },
    {
        name: "Layne's Chicken Fingers",
        category: 'food',
        subcategory: ['chicken'],
        badges: ['drive thru', 'open late', 'NFC mobile payments'],
        coordinates: [29.74497821979449, -95.41033020946566],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/oLa5wLU.png',
        website: 'https://www.layneschickenfingers.com',
        blurb: 'Chain restaurant specializing in its iconic chicken fingers, plus lemonade and Texas toast.',
        description: ['Chicken Fingers', 'Special Sauce', 'French Fries']
    },
    {
        name: 'Snooze, an A.M. Eatery',
        category: 'food',
        subcategory: ['breakfast', 'burritos', 'sandwiches'],
        badges: ['alcohol available'],
        coordinates: [29.801592997027548, -95.41029116058527],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/Wwqhz6d.png',
        website: 'https://www.snoozeeatery.com',
        blurb: 'Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails',
        description: ['Full bar', 'Bacon but Different', 'Creative Menu']
    },
    {
        name: 'Snooze, an A.M. Eatery',
        category: 'food',
        subcategory: ['breakfast', 'burritos', 'sandwiches'],
        badges: ['alcohol available'],
        coordinates: [29.744047828435875, -95.39075036458118],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/ENuHYXH.png',
        website: 'https://www.snoozeeatery.com',
        blurb: 'Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails',
        description: ['Full bar', 'Bacon but Different', 'Creative Menu']
    },
    {
        name: 'Asia Market Thai Lao Food',
        category: 'food',
        subcategory: ['ricebowl'],
        coordinates: [29.79111201462518, -95.37286016530489],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/ZIICkRg.jpg',
        website: 'http://www.asiamarketthailaofoods.com',
        blurb: 'Established storefront supplying Asian produce & groceries, also serving a Thai lunch & dinner menu.',
        description: ['Asian Market', 'Full Thai Food Menu', 'Noodles & Curries']
    },
    {
        name: 'Flying Biscuit',
        category: 'food',
        subcategory: ['breakfast'],
        badges: ['alcohol available'],
        coordinates: [29.758003441874767, -95.34618410261355],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/qxyPStD.png',
        website: 'https://flyingbiscuit.com',
        blurb: 'Branch of a laid-back chain known for Southern food & all-day breakfast selections.',
        description: ['Open early', 'chicken & waffles', 'homemade biscuits']
    },
    {
        name: 'Lyric Market',
        category: 'food',
        subcategory: ['hall'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.76310881612258, -95.36456102261619],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/hANqcZO.png',
        website: 'https://www.lyricmarket.com/',
        blurb: "Houston's most exciting and sophisticated food hall",
        description: ["Order From Web", 'Full Bar', 'Range of options']
    },
    {
        name: 'POST Market',
        category: 'food',
        subcategory: ['hall'],
        badges: ['NFC mobile payments', 'paid parking', 'outdoor seating', 'alcohol available', 'photogenic'],
        coordinates: [29.766078454632144, -95.36455736258664],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/8LXZmob.png',
        website: 'https://www.posthtx.com/eat',
        blurb: 'Diner style seating and cyberpunk vibes.',
        description: ['Shopping', 'Eating', 'Live performances']
    },
    {
        name: 'Underground Hall',
        category: 'food',
        subcategory: ['hall'],
        badges: ['alcohol available'],
        coordinates: [29.760386415990325, -95.36154140154935],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/cRslLrK.png',
        website: 'https://www.undergroundhall.com/',
        blurb: 'Casual destination with food vendors doling out global bites, plus draft beer & happy hour specials.',
        description: ['Happy Hour 2-6', 'Noodles', 'Burgers']
    },
    {
        name: "BB's Tex-Orleans",
        category: 'food',
        subcategory: ['seafood', 'crawfish', 'soup'],
        badges: ['alcohol available'],
        coordinates: [29.81679853144434, -95.43075744065375],
        neighborhood: 'Oak Forest',
        img: 'https://i.imgur.com/5aK3wLH.png',
        website: 'https://bbstexorleans.com',
        blurb: "Local Tex-Orleans chain serving po'boys, gumbo, fried seafood & more in a casual setting.",
        description: ['Crawfish', 'Gumbo', 'Fried Fish']
    },
    {
        name: "BB's Tex-Orleans",
        category: 'food',
        subcategory: ['seafood', 'crawfish', 'soup'],
        badges: ['outdoor seating', 'alcohol available'],
        coordinates: [29.78130193379262, -95.38796849551551],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/UHoh7Tn.png',
        website: 'https://bbstexorleans.com',
        blurb: "Local Tex-Orleans chain serving po'boys, gumbo, fried seafood & more in a casual setting.",
        description: ['Crawfish', 'Gumbo', 'Fried Fish']
    },
    {
        name: "BB's Tex-Orleans",
        category: 'food',
        subcategory: ['seafood', 'crawfish', 'soup'],
        badges: ['open late', 'alcohol available'],
        coordinates: [29.74424519171531, -95.38841579865903],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/agJyn5R.png',
        website: 'https://bbstexorleans.com',
        blurb: "Local Tex-Orleans chain serving po'boys, gumbo, fried seafood & more in a casual setting.",
        description: ['Crawfish', 'Gumbo', 'Fried Fish']
    },
    {
        name: "BB's Tex-Orleans",
        category: 'food',
        subcategory: ['seafood', 'crawfish', 'soup'],
        badges: ['outdoor seating', 'alcohol available'],
        coordinates: [29.733773605120188, -95.4261022899225],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/vPRgLRV.png',
        website: 'https://bbstexorleans.com',
        blurb: "Local Tex-Orleans chain serving po'boys, gumbo, fried seafood & more in a casual setting.",
        description: ['Crawfish', 'Gumbo', 'Fried Fish']
    },
    {
        name: '7Spice',
        category: 'food',
        subcategory: ['seafood', 'crawfish', 'soup'],
        coordinates: [29.936995628209772, -95.24866447987408],
        neighborhood: 'Humble',
        img: 'https://i.imgur.com/ExpOpZX.jpg',
        website: 'https://7spicecajun.com',
        blurb: 'Fast-casual chain prepping made-to-order Cajun seafood dishes, including popular fried shrimp.',
        description: ['Seafood boil', 'Corn & Potatoes', 'Crawfish']
    },
    {
        name: 'Hippo Burgers',
        category: 'food',
        subcategory: ['burgers'],
        coordinates: [29.902729653569942, -95.34997206587146],
        neighborhood: 'East Aldine',
        img: 'https://i.imgur.com/T9SYuRm.png',
        website: 'https://hippoburgers.com',
        blurb: 'Chain eatery known for its fresh, never-frozen burgers and buffalo chicken sandwiches, plus a patio.',
        description: ['Creative Burgers', 'Diverse Menu', 'Snacks']
    },
    {
        name: "Morton's The Steakhouse",
        category: 'food',
        subcategory: ['upscale', 'steak', 'soup', 'salads'],
        badges: ['alcohol available'],
        coordinates: [29.756924901573548, -95.36427486690646],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/NDYUIgG.png',
        website: 'https://www.mortons.com/location/mortons-the-steakhouse-houston-tx-downtown/?utm_source=Google&utm_medium=CPC&utm_campaign=MTHD-1163_TX-Houston-Downtown_Branded&utm_content=ch_google_adwords|trg_kwd-326515902124|crt_677467078720|kwmt_e|ps_|srct_g|trgt_|src_|devt_c|devm_|cid_894703348|lcl_9192926|fdi_&utm_term=morton%27s%20the%20steakhouse&gad_source=6&gbraid=0AAAAADpS1nmRvEaXQByQvZIHxdyzxEnHX&gclid=Cj0KCQjw2ZfABhDBARIsAHFTxGx0rTP-55xU5jOvCJ2ccmQy8kT6o6_H6koN6yNN-AH9B6SxNHBP7K0aAuUmEALw_wcB',
        blurb: 'Upscale chain for aged prime beef, seafood & other traditional steakhouse fare in a clubby space',
        description: ['Steak', 'Full bar', 'Downtown']
    },
    {
        name: "Morton's The Steakhouse",
        category: 'food',
        subcategory: ['upscale', 'steak', 'soup', 'salads'],
        badges: ['alcohol available'],
        coordinates: [29.742058565423644, -95.46245468028471],
        neighborhood: 'Galleria',
        img: 'https://i.imgur.com/gUCdiM5.png',
        website: 'https://www.mortons.com/location/mortons-the-steakhouse-houston-tx-galleria/#menus',
        blurb: 'Upscale chain for aged prime beef, seafood & other traditional steakhouse fare in a clubby space',
        description: ['Steak', 'Full bar', 'Galleria']
    },
    {
        name: "Hungry Howie's Pizza",
        category: 'food',
        subcategory: ['pizza'],
        coordinates: [29.901736784187758, -95.553412021421],
        neighborhood: 'Jersey Village',
        img: 'https://i.imgur.com/jN4nRox.png',
        website: 'https://www.hungryhowies.com/stores/tx/houston/9213-west-rd-suite-100?utm_source=google&utm_medium=organic&utm_campaign=googlebusinessprofile',
        blurb: 'Basic, counter-serve pizzeria chain popular for its flavored crusts, such as sesame & garlic herb.',
        description: ['Flavored crusts', 'Cajun Bread', 'Onion Crust']
    },
    {
        name: 'House of Pies',
        category: 'food',
        subcategory: ['dessert', 'breakfast', 'soup', 'salads'],
        badges: ['open late'],
        coordinates: [29.737118864189952, -95.41921689703939],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/kT7WhKM.png',
        website: 'https://houseofpies.com/',
        blurb: 'Classic 24-hour American diner serving burgers, salads, sandwiches, breakfast fare & homemade pies.',
        description: ['Lemon Meringue', 'Key Lime', 'Coconut Meringue']
    },
    {
        name: "Timmy Chan's",
        category: 'food',
        subcategory: ['chicken'],
        badges: ['drive thru'],
        coordinates: [29.946170791694453, -95.46510803077007],
        neighborhood: 'Greenspoint',
        img: 'https://i.imgur.com/XPMlMpQ.png',
        website: 'https://www.timmychanshouston.com/',
        blurb: 'Utilitarian Chinese joint with a drive-thru offering fast food such as chicken wings & fried rice.',
        description: ['Kool Aid', 'Chicken Wings', 'Fried Rice']
    },
    {
        name: "Timmy Chan's",
        category: 'food',
        subcategory: ['chicken'],
        badges: ['drive thru'],
        coordinates: [29.864652305790308, -95.40565798665216],
        neighborhood: 'Acres Home',
        img: 'https://i.imgur.com/MPtLL5H.png',
        website: 'https://www.timmychanshouston.com/',
        blurb: 'Utilitarian Chinese joint with a drive-thru offering fast food such as chicken wings & fried rice.',
        description: ['Kool Aid', 'Chicken Wings', 'Fried Rice']
    },
    {
        name: "Timmy Chan's",
        category: 'food',
        subcategory: ['chicken'],
        badges: ['drive thru'],
        coordinates: [29.844238187755664, -95.47286949870724],
        neighborhood: 'Central Northwest',
        img: 'https://i.imgur.com/C0M6SOh.png',
        website: 'https://www.timmychanshouston.com/',
        blurb: 'Utilitarian Chinese joint with a drive-thru offering fast food such as chicken wings & fried rice.',
        description: ['Kool Aid', 'Chicken Wings', 'Fried Rice']
    },
    {
        name: "Spanky's ",
        category: 'food',
        subcategory: ['pizza', 'chicken'],
        badges: ['alcohol available'],
        coordinates: [29.694876795984932, -95.29955061154651],
        neighborhood: 'Southeast Houston',
        img: 'https://i.imgur.com/KAPwDYt.jpg',
        website: 'https://www.spankyspizza.net/',
        blurb: 'This family-owned pizza parlor using from-scratch dough also offers burgers, pasta & a full bar.',
        description: ['Oven baked wings', 'Large pizzas', 'Full menu']
    },
    {
        name: 'Joey Uptown',
        category: 'food',
        subcategory: ['upscale', 'steak'],
        badges: ['paid parking', 'alcohol available'],
        coordinates: [29.74019123438663, -95.46277629362307],
        neighborhood: 'Uptown',
        img: 'https://i.imgur.com/CavBhh7.png',
        website: 'https://joeyrestaurants.com/location/joey-uptown',
        blurb: 'Relaxed, contemporary dining spot with a broad menu featuring international & regional dishes.',
        description: ['Fine dining', 'Full bar', 'Quality steak']
    },
    {
        name: 'Thirteen',
        category: 'food',
        subcategory: ['upscale', 'steak'],
        badges: ['hookah', 'paid parking', 'alcohol available'],
        coordinates: [29.752621777966795, -95.37569459231442],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/S8jcVg6.png',
        website: 'https://13htx.com',
        blurb: 'Upscale restaurant offering New American cuisine & a raw bar, plus a hookah and cocktail lounge.',
        description: ['Hookah', 'Full bar', 'Walkable Area']
    },
    {
        name: 'Seafood Man Shack',
        category: 'food',
        subcategory: ['seafood', 'crawfish'],
        badges: ['black owned', 'outdoor seating'],
        coordinates: [29.81584956949366, -95.32898273227359],
        neighborhood: 'Houston Gardens',
        img: 'https://i.imgur.com/2UoXXY7.png',
        website: 'https://www.instagram.com/theseafoodmanshack/',
        blurb: 'Laid-back seafood shack offering quick bites, including crawfish, shrimp, and gumbo.',
        description: ['Seafood boil', 'Fried seafood', 'Burgers']
    },
    {
        name: 'Boil House',
        category: 'food',
        subcategory: ['seafood', 'crawfish'],
        badges: ['drive thru', 'outdoor seating'],
        coordinates: [29.790529597726433, -95.39167411678872],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/2hKXN1q.png',
        website: 'https://www.theboilhouse.com',
        blurb: 'Open-air counter-serve featuring Cajun crawfish & shrimp boils with corn, plus outside tables.',
        description: ['High quality', 'Worth the price', 'King cake']
    },
    {
        name: 'Cantina Barba',
        category: 'food',
        subcategory: ['tacos', 'burritos'],
        badges: ['open late', 'outdoor seating', 'alcohol available'],
        coordinates: [29.790805407102635, -95.37342269156582],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/GKuJcT6.png',
        website: 'https://www.cantinabarba.com',
        blurb: 'Unfussy joint with late-night hours crafting house-smoked meat tacos, coffee, beer & mezcal.',
        description: ['Open late', 'Great tacos', 'Quality cocktails']
    },
    {
        name: "Dona Lena's",
        category: 'food',
        subcategory: ['tacos'],
        badges: ['alcohol available'],
        coordinates: [29.80193023090178, -95.4318876273503],
        neighborhood: 'Heights',           
        img: 'https://i.imgur.com/xihg7al.png',
        website: 'https://www.donalenatacos.com',
        blurb: 'Casual Mexican option dishing up quesabirria and other comfort eats plus margaritas.',        
        description: ['Tostadas', 'Tortas', 'Birria']
    },
    {
        name: "Culver's",
        category: 'food',
        subcategory: ['burgers'],
        badges: ['drive thru', 'NFC mobile payments'],
        coordinates: [29.98801261114251, -95.1927731083066],
        img: 'https://i.imgur.com/QBGyurN.png',
        neighborhood: 'Atascocita',
        website: 'https://www.culvers.com/restaurants/atascocita?utm_source=Google&utm_medium=Maps&utm_campaign=Google%20Places',
        blurb: 'Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.',
        description:['High quality fast food', 'Ice cream', 'Root beer']
    },
    {
        name: "Papa John's Pizza",
        category: 'food',
        subcategory: ['pizza'],
        badges: ['open late'],
        coordinates: [30.00041303571167, -95.16024942826793],
        neighborhood: 'Atascocita',
        img: 'https://i.imgur.com/XSn7t71.png',
        website: 'https://locations.papajohns.com/united-states/tx/77346/atascosita-%28humble%29/7591-fm-1960-road-east?utm_source=yext-listings&utm_medium=referral&y_source=1_MTA1OTI1NDgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D',
        blurb: 'Pizza take-out & delivery chain offering classic & specialty pizzas, plus wings, sides & desserts.',
        description: ['Wonderful GM', 'Better ingredients', 'Better pizza']
    },
    {
        name: 'Luna Pizzeria',
        category: 'food',
        subcategory: ['pizza'],
        badges: ['alcohol available'],
        coordinates: [29.77258286899414, -95.398930888628],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/IOMxpjF.png',
        website: 'https://www.lunapizzeria.com',
        blurb: 'Modern, family-friendly pizzeria turning out pies with creative toppings, plus salads & sandwiches.',
        description: ['Prosciutto & arugala', 'Spicy andouille', 'Games']
    },
    {
        name: 'Cowboys & Indians',
        category: 'food',
        subcategory: ['upscale'],
        badges: ['paid parking', 'alcohol available'],
        coordinates: [29.767238194517333, -95.40970321005263],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/bUKClkp.png',
        website: 'https://www.cni713.com',
        blurb: 'Easygoing eatery offering Indian & Southern fare such as burgers & kebabs in low-key surrounds.',
        description: ['Date night', 'Drinks', 'Indian western fusion']        
    },
    {
        name: 'Kami Ramen & Sushi',
        category: 'food',
        subcategory: ['ramen', 'sushi', 'soup'],
        badges: ['alcohol available'],
        coordinates: [30.003902312520257, -95.27018922268779],
        neighborhood: 'Deerbrook',
        img: 'https://i.imgur.com/xTFTDOH.png',
        website: 'https://www.kamiramenhumble.com',
        blurb: 'Casual, anime-themed restaurant serving ramen, sushi, and other Japanese eats plus sake and beer.',
        description: ['Ramen', 'Pepper Tuna', 'Sushi Rolls']
    },
    {
        name: 'Somisomi',
        category: 'food',
        subcategory: ['dessert'],
        coordinates: [29.788748228653198, -95.77294693210428],
        neighborhood: 'Katy',
        img: 'https://i.imgur.com/1y81OeD.png',
        website: 'https://somisomi.com',
        blurb: 'Playful Korean-style soft serve in flavors like matcha and black sesame served in specialty cones.',
        description: ['Fun Ice Cream', 'Refreshing', 'Colorful']
    },
    {
        name: "Simple Simon's",
        category: 'food',
        subcategory: ['pizza', 'sandwiches'],
        coordinates: [29.930726076398745, -95.30876976284986],
        neighborhood: 'East Aldine',
        img: 'https://i.imgur.com/S6K4xYy.png',
        website: 'https://www.simplesimonspizza.com',
        blurb: 'Classic & creative pizzas, subs & calzones fill the menu at this easygoing Italian chain.',
        description: ['Take Out', 'Sandwiches', 'Pizza']
    },
    {
        name: 'Flower & Cream',
        category: 'food',
        subcategory: ['dessert'],
        coordinates: [29.756607768458114, -95.40288712731353],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/xR6Rz7v.png',
        website: 'https://www.flowerandcream.com',
        blurb: 'Ice cream shop featuring a variety of flavors, including cereal milk and roasted strawberry.',
        description: ['Unique Flavors', 'Seasonal Flavors', 'Ube Ice Cream']
    },
    { 
        name: "Jersey Mike's Subs",
        category: 'food',
        subcategory: ['sandwiches'],
        badges: ['NFC mobile payments'],
        coordinates: [29.925487840354876, -95.19694102868498],
        neighborhood: 'Summerwood',
        img: 'https://i.imgur.com/bFnrKIr.png',
        website: 'https://www.jerseymikes.com/menu',
        blurb: 'New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.',
        description: ['Fresh Sandwiches', 'Hot Peppers', "Mike's Ways"]
    },
    {
        name: 'Sv Donuts & Kolaches',
        category: 'food',
        subcategory: ['breakfast'],
        coordinates: [29.897511116995208, -95.21243011252079],
        neighborhood: 'Summerwood',
        img: 'https://i.imgur.com/BxEIdFC.png',
        website: 'https://restaurantguru.com/Sv-Donuts-and-Kolaches-Houston',
        blurb: 'Donut shop known for its kolaches, plus breakfast sandwiches, and custom orders.',
        description: ['Sausage Kolaches', 'Chocolate Donuts', 'Chocolate Milk']
    },
    {
        name: 'Agnes & Sherman',
        category: 'food',
        subcategory: ['upscale'],
        badges: ['alcohol available'],
        coordinates: [29.80263725272135, -95.40106693761525],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/CizVixn.png',
        website: 'https://www.agnesandsherman.com',
        blurb:  "Agnes and Sherman’s mission is to deliver a nostalgic, whimsical, and inclusive dining experience through the lens of Asian American food; and by doing so, expand the definition of American culture",
        description: ['Reservations', 'Asian - American Fusion', 'Sharable Plates']
    },
    {
        name: "Triple J's Smokehouse",
        category: 'food',
        subcategory: ['bbq'],
        badges: ['black owned'],
        coordinates: [29.81917729379479, -95.30228403326238],
        neighborhood: 'Houston Gardens',
        img: 'https://i.imgur.com/2Wvua82.png',
        website: 'https://triplejsmokehouse.com',
        blurb: 'Burgers, ribs, sandwiches & potatoes round out the menu at this casual spot known for smoked meats.',
        description: ['Brisket', 'Ribs', 'Boudain']
    },
    {
        name: 'Pappas Bar-B-Q',
        category: 'food',
        subcategory: ['bbq', 'sandwiches', 'breakfast'],
        badges: ['drive thru', 'NFC mobile payments'],
        coordinates: [29.871432138949643, -95.32843650525928],
        neighborhood: 'Little York',
        img: 'https://i.imgur.com/FANOjRk.png',
        website: 'https://pappasbbq.com/home/',
        blurb: 'Long-standing chain dishing up Texas-style smoked meats & sides in a relaxed counter-serve setting.',
        description: ['BBQ Sandwiches', 'Breakfast tacos', 'Pecan Pie']
    },
    {
        name: 'Sichuan Pepper Express',
        category: 'food',
        subcategory: ['ricebowl', 'soup'],
        coordinates: [29.868824247412608, -95.32745028567592],
        neighborhood: 'Little York',
        img: 'https://i.imgur.com/o5dq5N1.png',
        website: 'https://sichuanpepperexpress.com',
        blurb: "Fast-food option at the Northeast Marketplace for Chinese standards such as General Tso's chicken and orange chicken, plus catering.",
        description: ['Combo plates', 'Soup', 'Large portions']
    },
    {
        name: 'Taco Real',
        category: 'food',
        subcategory: ['tacos', 'breakfast', 'burritos'],
        coordinates: [29.9032297520123, -95.31061365838374],
        neighborhood: 'Houston Gardens',
        img: 'https://i.imgur.com/wgp6t5t.png',
        website: 'https://www.tacoreal.com',
        blurb: 'Relaxed spot for breakfast, tacos, and other traditional Mexican eats, plus coffee.',
        description: ['Breakfast tacos', 'Homemade Tortillas', 'Mexican Sodas']
    },
    {
        name: 'District 7',
        category: 'food',
        subcategory: ['burgers', 'outdoor seating', 'alcohol available', 'salads'],
        coordinates: [29.752103485592464, -95.37487153428916],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/vm8lMvI.png',
        website: 'https://www.district7grill.com',
        blurb: 'Bustling chain serving eclectic fare such as mussels, muffalettas & burgers in colorful digs.',
        description: ['Wings', 'Sandwiches', 'Wine']
    },
    {
        name: "Lankford's Grocery & Market",
        category: 'food',
        subcategory: ['burgers', 'salads'],
        badges: ['outdoor seating', 'alcohol available'],
        coordinates: [29.75001334070072, -95.38387329126209],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/3CNPbOI.png',
        website: 'https://midtown.lankfordsburgers.com',
        blurb: 'No-frills spot for classic American eats including burgers & hearty breakfasts in a kitschy space.',
        description: ['Burgers', 'Fried Pickles', 'Outdoor Seating']
    },
    {
        name: 'Fat Bao',
        category: 'food',
        subcategory: ['sandwiches', 'breakfast', 'tacos', 'salads'],
        badges: ['alcohol available'],
        coordinates: [29.735109780616774, -95.41800455744735],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/q49vIEQ.png',
        website: 'https://www.fatbaohouston.com',
        blurb: 'Simple Asian fusion joint offering steamed buns stuffed with meat, fish, vegetables or sweets.',
        description: ['Bao', 'Fries', 'Edamame']
    },
    {
        name: "Tony's Italian Delicatessen",
        category: 'food',
        subcategory: ['sandwiches'],
        coordinates: [30.117366594399364, -95.55401930269417],
        neighborhood: 'Tomball',
        img: 'https://i.imgur.com/UFcOJfi.png',
        website: 'https://tonysitaliandelicatessen.com',
        blurb: 'Casual sandwich shop dishing up hot and cold subs, plus salads.',
        description: ['Sandwiches', 'Muffaletta', 'The De Niro']
    },
    {
        name: "Lennys Grill & Subs",
        category: 'food',
        subcategory: ['sandwiches'],
        coordinates: [30.004289246025856, -95.2919931972898],
        neighborhood: 'Humble',
        img: 'https://i.imgur.com/6IXndO8.png',
        website: 'https://www.lennys.com/locations/lennys-grill-subs-281/?gad_source=1&gad_campaignid=22329163159&gclid=Cj0KCQjw5ubABhDIARIsAHMighZnJ0QWm-dnz49XcnRfLcl8qj-zyDd7oD2Vq2oOprgnkhVzP-W8cbEaAhpBEALw_wcB',
        blurb: 'Outpost of a chain specializing in Philly-style cheesesteaks & submarine sandwiches.',
        description: ['Sandwiches', 'Chicken Salad', 'Philly Cheese']
    },
    {
        name: 'Gaspachos Mexican Bites',
        category: 'food',
        subcategory: ['tacos'],
        coordinates: [29.732792699377697, -95.42422401272596],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/F7FHJfa.png',
        website: 'https://www.gaspachoshtx.com',
        blurb: 'Easygoing Mexican joint serving street tacos and other favorites, plus beer, cocktails, and dog treats.',
        description: ['Juices', 'Tacos', 'Fruit Bowls']
    },
    {
        name: 'The Burger Joint',
        category: 'food',
        subcategory: ['burgers', 'sandwiches'],
        badges: ['outdoor seating', 'alcohol available'],
        coordinates: [29.804033915214887, -95.40988938793168],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/t9F4bpx.png',
        website: 'https://burgerjointhtx.com',
        blurb: 'Casual option dishing up burgers and craft beer, with shaded outdoor seating and sports on TV.',
        description: ['Creative Burgers', 'Hot dogs', 'Chicken Sandwiches']
    },
    {
        name: 'Rodeo Goat',
        category: 'food',
        subcategory: ['burgers', 'salads'],
        badges: ['paid parking', 'outdoor seating', 'alcohol available'],
        coordinates: [29.74980036784446, -95.3564042704112],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/KSGarKU.png',
        website: 'https://www.rodeogoat.com/houston/',
        blurb: 'Casual joint offering inventive variations on house-ground burgers and a lengthy craft-beer lineup, with takeout options.',
        description: ['Burgers', 'Cocktails', 'Milkshakes']
    },
    {
        name: 'Two Hands Fresh Corn Dogs',
        category: 'food',
        subcategory: ['hotdogs'],
        coordinates: [29.788814207973186, -95.77300638786825],
        neighborhood: 'Katy',
        img: 'https://i.imgur.com/9fdJSnt.png',
        website: 'https://www.twohandsus.com',
        blurb: 'Eatery dishing up Korean-style corn dogs with a variety of toppings plus kimchi fries.',
        description: ['Kimchi Fries', 'Hot Cheeto Toppings', 'Drinks']
    },
    {
        name: 'The Waffle Bus',
        category: 'food',
        subcategory: ['chicken'],
        coordinates: [29.80250060993677, -95.41044891450004],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/YsUgurm.jpeg',
        website: 'https://www.thewafflebus.com',
        blurb: 'Laid-back restaurant serving savory & sweet waffle sandwiches, plus hot chicken snacks.',
        description: ['Chicken', 'Waffles', 'Sweet Sandiwches']
    },
    {
        name: 'The Waffle Bus',
        category: 'food',
        subcategory: ['chicken'],
        coordinates: [29.738872423986365, -95.39901834587168],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/zEa5LEB.png',
        website: 'https://www.thewafflebus.com',
        blurb: 'Laid-back restaurant serving savory & sweet waffle sandwiches, plus hot chicken snacks.',
        description: ['Chicken', 'Waffles', 'Sweet Sandiwches']
    },
    {
        name: 'Marmo',
        category: 'food',
        subcategory: ['upscale', 'salads', 'pasta'],
        badges: ['alcohol available'],
        coordinates: [29.744837337864322, -95.39033391153052],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/FBrR44x.jpeg',
        website: 'https://marmoitalian.com',
        blurb: 'Italian chophouse concept from Atlas Restaurant Group.',
        description: ['Happy Hour', 'Cocktails', 'Delicious']
    },
    {
        name: 'Toro Toro',
        category: 'food',
        subcategory: ['upscale', 'salads'],
        badges: ['alcohol available'],
        coordinates: [29.754135330781605, -95.36270750186235],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/20ccHyw.png',
        website: 'https://www.torotorohouston.com',
        blurb: 'Global Pan-Latin steakhouse at the Four Seasons Hotel offering rodízio-style churrasco steaks and Asian dishes.',
        description: ['Inside Four Seasons', 'Breakfast, Lunch, Dinner', 'Happy Hour 3pm - 6pm']
    },
    {
        name: 'Spindletop',
        category: 'food',
        subcategory: ['upscale', 'soup', 'salads', 'pasta'],
        badges: ['alcohol available', 'photogenic'],
        coordinates: [29.757210181311688, -95.36954758353014],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/ZOv1hRe.png',
        website: 'https://www.instagram.com/officialspindletophouston/?hl=en',
        blurb: 'Upscale revolving restaurant perched atop the Hyatt hotel serving Southwestern-inspired seafood.',
        description: ['Inside Hyatt', 'Revolving Restuarant', 'Reservations']
    },
    {
        name: 'The Sunrise House',
        category: 'food',
        subcategory: ['breakfast', 'salads'],
        badges: ['paid parking', 'vegetarian options', 'alcohol available'],
        coordinates: [29.738935860322403, -95.40586450262902],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/H0fKMWt.png',
        website: 'https://www.thesunrisehouse.com',
        blurb: 'Upscale restaurant serving an array of breakfast and brunch classics in an elevated setting.',
        description: ['Brunch', 'Affordable', 'Cute']
    },
    {
        name: "Lucille's",
        category: 'food',
        subcategory: ['chicken', 'soup', 'salads'],
        badges: ['black owned', 'vegetarian options', 'alcohol available'],
        coordinates: [29.723799143236427, -95.38506435895276],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/4e4itNW.png',
        website: 'https://www.lucilleshouston.com',
        blurb: 'Modern takes on Southern classics by a classically trained chef served in a cozy, vintage house.',
        description: ['Fried Green Tomatoes', 'Soul Food', 'Fried Fish']
    },
    {
        name: 'Onion Creek',
        category: 'food',
        subcategory: ['burgers', 'breakfast', 'tacos', 'salads', 'hotdogs'],
        badges: [ 'outdoor seating', 'vegetarian options', 'alcohol available'],
        coordinates: [29.781753679987595, -95.39102295778669],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/l7I5cqS.png',
        website: 'https://www.onioncreekcafe.com',
        blurb: 'Casual breakfast & lunch eatery serving burgers & local beers inside or on the woodsy outdoor patio.',
        description: ['Tacos', 'Sandwiches', 'Pizza']
    },
    {
        name: 'Midwest Coney Connection',
        category: 'food',
        subcategory: ['hotdogs'],
        badges: ['black owned'],
        coordinates: [29.73733267569881, -95.58346995304211],
        neighborhood: 'Westside',
        img: 'https://i.imgur.com/7Ryj662.png',
        website: 'https://midwestconeyconnection.com/',
        blurb: 'Hot dogs, wings, fries & Philly cheesesteak egg rolls offered in an informal counter-serve setting.',
        description: ['Chili Dogs', 'Philly Cheese Steak Egg Rolls', 'Texas Frito Pie']
    },
    {
        name: "Gotti's",
        category: 'food',
        subcategory: ['seafood', 'breakfast'],
        badges: ['black owned', 'open late', 'paid parking', 'alcohol available'],
        coordinates: [29.75216243542135, -95.35437411958986],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/Cvk1yFd.png',
        website: 'https://www.gottis.com',
        blurb: 'Convivial hangout with a contemporary vibe serving shrimp, fried catfish, gumbo, and more.',
        description: ['Full bar', 'Televised Sports', 'Happy Hour']
    },
    {
        name: 'JINYA Ramen Bar',
        category: 'food',
        subcategory: ['ramen', 'soup'],
        badges: ['alcohol available'],
        coordinates: [29.803223903801737, -95.40544469527859],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/OxWGhO1.png',
        website: 'https://www.jinyaramenbar.com/',
        blurb: 'Restaurant serving traditional Japanese noodle soups plus vegetarian and vegan options in a casual setting.',
        description: ['Ramen', 'Edamame', 'Miso Garlic']
    },
    {
        name: "nobie's",
        category: 'food',
        subcategory: ['upscale', 'dessert'],
        badges: ['michelin rated', 'open late', 'vegetarian options', 'alcohol available'],
        coordinates: [29.73535627273937, -95.41003810405576],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/NhgssIj.png',
        website: 'https://www.nobieshtx.com',
        blurb: 'Intimate spot serving New American dishes & craft cocktails, with a patio & a vinyl soundtrack.',
        description: ['Small Plates', 'Delicious Pies', 'Romantic']
    },
    {
        name: "Killen's",
        category: 'food',
        subcategory: ['upscale', 'sandwiches', 'chicken', 'steak', 'salads'],
        badges: ['michelin rated', 'vegetarian options', 'alcohol available'],
        coordinates: [29.770632130472293, -95.39762377700288],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/pVgNemZ.png',
        website: 'https://www.killens.com',
        blurb: 'Relaxed, brick-lined restaurant with traditional Southern comfort food & happy hours.',
        description: ['Deviled Eggs', 'Steak', 'Sanwiches']
    },
    {
        name: "The Original Ninfa's",
        category: 'food',
        subcategory: ['tacos', 'salads'],
        badges: ['outdoor seating', 'alcohol available'],
        coordinates: [29.756943373593632, -95.34251268012594],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/syAJRBM.png',
        website: 'https://ninfas.com',
        blurb: 'Longtime casual spot with covered outdoor seating serving fajitas, margaritas & other Mexican fare.',
        description: ['Fajitas & Margaritas', 'Reservations Required', 'Parking Limited']
    },
    {
        name: "Bibo's Bistro",
        category: 'food',
        subcategory: ['pho', 'sandwiches', 'soup'],
        badges: ['paid parking', 'outdoor seating', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.920214406038113, -95.20296607394474],
        neighborhood: 'Summerwood',
        img: 'https://i.imgur.com/QmUq918.png',
        website: 'https://www.bibosbistro.com',
        blurb: 'Elevated Vietnamese fusion at the Redemption Square offering happy hour, great cocktails, and vegetarian dishes.',
        description: ['$5 Pho Tuesdays', 'Drunken Pig', 'Banh Mi']
    },
    {
        name: 'Resilience Viet Kitchen & Bar',
        category: 'food',
        subcategory: ['pho', 'sandwiches', 'soup'],
        badges: ['outdoor seating', 'alcohol available'],
        coordinates: [29.767893781676012, -95.62471191844388],
        neighborhood: 'Energy Corridor',
        img: 'https://i.imgur.com/2YUo65q.png',
        website: 'https://www.resiliencevietkitchen.com',
        blurb: 'Neighborhood spot for Vietnamese classics including pho and vermicelli, plus beer, cocktails, and bubble tea.',
        description: ['Pho', 'Happy Hour', 'Banh Mi']
    },
    {
        name: 'Bamboo House',
        category: 'food',
        subcategory: ['ricebowl', 'soup'],
        badges: ['NFC mobile payments', 'vegetarian options'],
        coordinates:[29.94003107975492, -95.27055933669807],
        neighborhood: 'Humble',
        img: 'https://i.imgur.com/4OweZ8q.png',
        website: 'https://bamboohousehumble.com',
        blurb: 'Informal restaurant featuring roasted duck, plus noodle dishes, shared plates & other Chinese fare.',
        description: ['Peking Duck', 'Sharable Portions', 'Great takeout']
    },
    {
        name: 'Daily Gather',
        category: 'food',
        subcategory: ['breakfast', 'sandwiches', 'burgers'],
        badges: ['paid parking', 'outdoor seating', 'alcohol available', 'salads', 'soup'],
        coordinates: [29.780432990413235, -95.5612708627165],
        neighborhood: 'CityCentre',
        img: 'https://i.imgur.com/RPw3M6J.jpeg',
        website: 'https://www.dailygather.com',
        blurb: 'Classic American dishes served in a casual setting with rotisserie chicken, oysters, and charcuterie.',
        description: ['Brunch', 'Cocktails', 'International Cusiine']
    },
    {
        name: 'The Wing Boss',
        category: 'food',
        subcategory: ['chicken'],
        badges: ['black owned', 'alcohol available'],
        coordinates: [29.688094181128882, -95.39125891146672],
        neighborhood: 'Astrodome Area',
        img: 'https://i.imgur.com/PnWMhW2.png',
        website: 'https://thewingbosshtx.com',
        blurb: 'Casual eatery dishing up wings with a variety of sauces, plus fries, and cocktails.',
        description: ['Honey Zesty Garlic', 'Boudin Rolls', 'Fried Fish']
    },
    {
        name: "Gatlin's BBQ",
        category: 'food',
        subcategory: ['bbq'],
        badges: ['black owned', 'alcohol available'],
        coordinates: [29.820401606873304, -95.4290753018217],
        neighborhood: 'Oak Forest',
        img: 'https://i.imgur.com/G4TntbI.png',
        website: 'https://www.gatlinsbbq.com',
        blurb: 'Family-owned business with smoked meats, including beef ribs & brisket, from a mobile service.',
        description: ['EJ Combo', 'Mac & Cheese', 'Spare Ribs Baked Potato']
    },
    {
        name: 'Bungalow',
        category: 'food',
        subcategory: ['upscale', 'steak', 'pasta', 'salads', 'soup'],
        badges: ['black owned', 'open late', 'alcohol available'],
        coordinates: [29.76120075311379, -95.36138143591064],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/UOxUaUr.png',
        website: 'https://bungalowdining.com',
        blurb: 'Upscale steakhouse and cocktail bar with a variety of dining areas and a rooftop patio, plus happy hours.',
        description: ['$100+/person', 'Fried Lobster Tail', 'Truffle Pasta']
    },
    {
        name: "Baby Barnaby's",
        category: 'food',
        subcategory: ['breakfast'],
        coordinates: [29.748292986935475, -95.38827045199021],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/ljqqBip.png',
        website: 'https://barnabyscafe.com/babybreakfast.html',
        blurb: 'Casual, beloved American eatery specializing in breakfast, including pancakes and chicken and waffles.',
        description: ['Migas', 'Breakfast Tacos', 'Steak & Eggs']
    },
    {
        name: 'Common Bond Bistro & Bakery',
        category: 'food',
        subcategory: ['dessert'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.803464186060143, -95.40545136861638],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/jfgsXxd.png',
        website: 'https://www.commonbondcafe.com',
        blurb: 'Neighborhood bistro, bakery, brassery, and on-the-go restaurants where the community gathers to bond over exceptional pastries.',
        description: ['Macarons', 'Croissants', 'Weekend Brunch']
    },
    {
        name: 'Pho Binh',
        category: 'food',
        subcategory: ['pho', 'ricebowl', 'soup'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.78181156056512, -95.39020429631103],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/XQz3Cup.png',
        website: 'https://www.orderphobinhheights.com',
        blurb: 'Homemade pho & banh mi, plus rice & noodle dishes, offered in an informal Vietnamese eatery.',
        description: ['Cocktails', 'Rice plates', 'Banh Mi']
    },
    {
        name: 'Pho Saigon',
        category: 'food',
        subcategory: ['pho', 'ricebowl', 'soup'],
        badges: ['NFC mobile payments'],
        coordinates: [29.74513432872236, -95.37761516227405],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/YpuHNcE.png',
        website: 'https://www.thephosaigon.com',
        blurb: 'Informal eatery serving a variety of beef noodle soups (pho) & other classic Vietnamese fare.',
        description: ['Smoothies', 'Rice & Noodles', 'Pho']
    },
    {
        name: 'The Finn',
        category: 'food',
        subcategory: ['hall'],
        badges: ['paid parking', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.75871439561315, -95.3637995326293],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/478RJDK.png',
        website: 'https://www.thefinnhou.com',
        blurb: 'European-inspired, art deco food hall with casual, diverse dining options, bars & a cocktail lounge.',
        description: ['Cocktail lounge', 'Trendy', 'Diverse dining options']
    },
    {
        name: 'Pappas Bros. Steakhouse',
        category: 'food',
        subcategory: ['upscale', 'steak'],
        badges: ['michelin rated', 'alcohol available'],
        coordinates: [29.737239070730556, -95.48167207941405],
        neighborhood: 'Uptown',
        img: 'https://i.imgur.com/hVoFHzy.png',
        website: 'https://pappasbros.com/home/',
        blurb: 'Premier destination for top-quality, dry-aged steaks, an award-winning wine list, and impeccable service in a classic, upscale setting.',
        description: ['Lamb chops', 'Filet Mignon', 'Prime New York Strip']
    },
    {
        name: "Brennan's Houston",
        category: 'food',
        subcategory: ['upscale', 'steak', 'soup'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.742998333612533, -95.38144482186182],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/32yPlr0.png',
        website: 'https://www.brennanshouston.com',
        blurb: 'New Orleans character & cuisine shine at this decadent eatery serving turtle soup, oysters & more.',
        description: ['Crawfish Enchilada', 'Grilled Oysters', 'Snapping Turtle Soup']
    },
    {
        name: 'Gypsy Poet',
        category: 'food',
        subcategory: ['pizza'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.790590582826006, -95.3874896355487],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/yOoyMEf.png',
        website: 'https://tgp.revelup.online/store/2/category/156/subcategory/157',
        blurb: 'Live poetry, open-mic sessions & patio dining at a popular hangout for artisanal wood-fired pizza.',
        description: ['Fancy Backpacker', 'Dream Catcher', "Margherita 'The Queen'"]
    },
    {
        name: "Gus's World Famous Fried Chicken",
        category: 'food',
        subcategory: ['chicken'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.76760581182867, -95.37654662971858],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/VBGM7c8.png',
        img: 'https://i.imgur.com/tkoDnG0.png',
        website: 'https://www.gusfriedchicken.com/locations/houston-texas',
        blurb: 'Long-running chain serving spicy fried chicken & comfort sides in a low-key setting.',
        description: ['Fried Okra', 'Jalapenos', 'Great Fried Chicken']
    },
    {
        name: "Japaneiro's",
        category: 'food',
        subcategory: ['sushi'],
        badges: ['paid parking', 'NFC mobile payments', 'outdoor seating', 'alcohol available'],
        coordinates: [29.597236327219413, -95.6215611475929],
        neighborhood: 'Sugar Land',
        img: 'https://i.imgur.com/P3TDzJW.png',
        website: 'https://www.japaneiro.com',
        blurb: 'Inventive Japanese-Latin eats including fusion sushi rolls & margaritas served in a bustling space.',
        description: ['Angus Tostadas', 'Japacado', 'Tajadas']
    },
    {
        name: 'Lago Mariscos',
        category: 'food',
        subcategory: ['seafood', 'soup', 'salads'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.59805202203651, -95.6177601861514],
        neighborhood: 'Sugar Land',
        img: 'https://i.imgur.com/UMMRwQn.png',
        website: 'https://lagomariscostx.squarespace.com',
        blurb: "Authentic Mexican food and a large selection of seafood, along with a patio, live music, and a kids' menu.",
        description: ['Jalapenos Rellenos', 'Oysters', 'Ceviches']
    },
    {
        name: 'Bun Slut',
        category: 'food',
        subcategory: ['burgers'],
        badges: ['open late'],
        coordinates: [29.744180628468033, -95.3881707188817],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/RZcnqN6.png',
        website: 'https://www.eatbunslut.com',
        blurb: 'BunSlut is flipping the juiciest smash burgers, crispy fries, and creamy milkshakes in town—made with all-natural halal beef.',
        description: ['Open until 4am', 'Sliders', 'Cherry Peppers & Avocado']
    },
    {
        name: "Gold Tooth Tony's",
        category: 'food',
        subcategory: ['pizza'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.803051818398682, -95.41075134525713],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/IyhipGq.png',
        website: 'https://goldtoothtonys.com',
        blurb: 'Casual pizzeria dishing up Detroit-style pies with a variety of toppings, plus wings and Brussels sprouts.',
        description: ['Mac Balls', 'Fried Brussels Sprouts', 'Garlic Parm Wings']
    },
    {
        name: 'ChòpnBlọk',
        category: 'food',
        subcategory: ['ricebowl', 'salads'],
        badges: ['black owned'],
        coordinates: [29.74422459173191, -95.3876818360475],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/5VMBpgn.png',
        website: 'https://chopnblok.co',
        blurb: 'Modern take on West African cuisine served in a casual setting.',
        description: ['Golden Bowl', 'Meat Minnie Pies', 'Also in POST Market']
    },
    {
        name: 'Trendy Dumpling',
        category: 'food',
        subcategory: ['dumplings', 'ricebowl', 'ramen', 'soup'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.728544213335404, -95.43208947280887],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/vDJlxxM.jpeg',
        website: 'Soup & steamed dumplings, noodles, & traditional Sichuan dishes served in modern & vibrant space.',
        blurb: 'Soup & steamed dumplings, noodles, & traditional Sichuan dishes served in modern & vibrant space.',
        description: ['Beijing Duck', 'Crispy Bottom Bao', 'Hand Pulled Noodles']
    },
    {
        name: 'Nan Xiang Express',
        category: 'food',
        subcategory: ['dumplings', 'ricebowl'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.918406697322904, -95.6136917762065],
        neighborhood: 'Cypress',
        img: 'https://i.imgur.com/YRHouXa.png',
        website: 'https://nanxiangexpress.com',
        blurb: 'Nan Xiang is synonymous with soup dumplings. Our daily menu offers authentic Shanghai-style comfort food from Crispy Bottom Buns to Organic Soy Milk.',
        description: ['Soup Dumplings', 'Dim Sum', 'Noodles']
    },
    {
        name: 'Ramen Moto',
        category: 'food',
        subcategory: ['ramen', 'ricebowl', 'soup'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.73889035081645, -95.41531677376838],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/zMNWSpy.png',
        website: 'https://www.ramenmototx.com',
        blurb: "Ramen Moto is a cozy Japanese izakaya in Houston's Upper Kirby neighborhood, renowned for its 20-hour simmered broths, house-made noodles, and a diverse menu of ramen and small plates, perfect for late-night dining.",
        description: ['Burnt Garlic Ramen', 'Lava Toast', 'Free parking']
    },
    {
        name: 'Quan Ba Ky',
        category: 'food',
        subcategory: ['seafood', 'crawfish', 'soup'],
        coordinates: [29.70492898957481, -95.5829393783336],
        neighborhood: 'Chinatown',
        img: 'https://i.imgur.com/jdeTqfE.png',
        website: 'https://www.yelp.com/biz/quan-ba-ky-houston',
        blurb: 'Casual Vietnamese restaurant serving garlic noodles, lobster, pho, and other familiar dishes.',
        description: ['Vietnamese Crawfish', 'Garlic Shrimp', 'Crab legs']
    },
    {
        name: 'Lucy Ethiopian',
        category: 'food',
        subcategory: ['ricebowl', 'pasta', 'salads'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.713400060222245, -95.50424693622573],
        neighborhood: 'Galleria',
        img: 'https://i.imgur.com/JCaoXib.png',
        website: 'https://lucyhouston.com',
        blurb: 'Family-run eatery prepares Ethiopian dishes in a red-hued, art-filled space with a cozy lounge area.',
        description: ['Family style', 'Kitfo', 'Meat & Veggies Combo']
    },
    {
        name: 'Narwhal Jousting Club',
        category: 'food',
        subcategory: ['burgers', 'chicken', 'hotdogs'],
        badges: ['NFC mobile payments'],
        coordinates: [29.76878211492947, -95.41076234150462],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/AzQmlau.png',
        website: 'https://www.narwhaljoustingclub.com',
        blurb: 'Counter-serve sandwich shop serving fried chicken, tacos, hot dogs, and other quick bites in a casual setting.',
        description: ['Prosperity Burger', 'MC Hotdog', 'Limited Hours of Operation']
    },
    {
        name: 'La Calle Tacos',
        category: 'food',
        subcategory: ['tacos'],
        badges: ['paid parking', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.751880331090483, -95.37635323659572],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/9eV9nWP.png',
        website: 'https://lacalletacos.com/',
        blurb: 'Casual taqueria serving Mexican street eats such as tacos and tortas, plus margaritas.',
        description: ['Located in Bagby Park', 'Margaritas', 'Mexican food']
    },
    {
        name: "D & L's Cajun Kitchen",
        category: 'food',
        subcategory: ['chicken', 'seafood', 'soup'],
        badges: ['NFC mobile payments'],
        coordinates: [29.89031157943366, -95.30136093105763],
        neighborhood: 'Houston Gardens',
        img: 'https://i.imgur.com/0SMCYno.png',
        website: 'https://www.facebook.com/DLsCajunKitchen/',
        blurb: 'Casual restaurant dishing up soul food, including turkey wings, oxtails, and smothered pork chops.',
        description: ['Fried Catfish', 'Smothered Pork Chops', 'Turkey Necks']
    },
    {
        name: "Doña Leti’s",
        category: 'food',
        subcategory: ['tacos', 'burritos', 'salads'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.77847451694044, -95.42986816878614],
        neighborhood: 'Memorial Park',
        img: 'https://i.imgur.com/cql0Ijc.jpeg',
        website: 'https://www.frutasdonaleti.com',
        blurb: 'Casual Mexican eatery dishing up standards and specialties, plus cocktails, and happy-hour specials.',
        description: ['Happy hour', 'Chorizo Queso', 'Full bar']
    },
    {
        name: 'Trill Burgers',
        category: 'food',
        subcategory: ['burgers'],
        badges: ['Open Late', 'NFC mobile payments'],
        coordinates: [29.733928348834223, -95.40997044185593],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/6Mfp84J.png',
        website: 'https://www.trill-burgers.com',
        blurb: "Co-founded by rap legend Bun B, Trill Burgers is a Houston-based smashburger spot known for its award-winning burgers, Trill Sauce, and pop-up roots, now serving fans at its Montrose location with a drive-thru. Named “Best Burger in America” by Good Morning America and a hit at major festivals, Trill Burgers blends food, culture, and community.",
        description: ['Burgers', 'Chicken Tenders', 'Fries']
    },
    {
        name: 'EaDough',
        category: 'food',
        subcategory: ['bakery', 'breakfast'],
        badges: ['NFC mobile payments'],
        coordinates: [29.742907444557222, -95.34776879277544],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/zH9syVL.png',
        website: 'https://eadough.com',
        blurb: 'The best breakfast place in Houston, Texas. We offer a delicious variety of breakfast, Pastries, Beverages and Lunch.',
        description: ['Bagels', 'Sandwiches', 'Salads']
    },
    {
        name: 'Tacos Frontera',
        category: 'food',
        subcategory: ['tacos', 'burritos'],
        badges: ['alcohol available'],
        coordinates: [29.78684670551906, -95.75126095239929],
        neighborhood: 'Katy',
        img: 'https://i.imgur.com/PSPTdoU.png',
        website: 'https://www.instagram.com/tacos.frontera/?hl=en',
        blurb: "Houston's first Tijuana-style tacos.",
        description: ['Tacos', 'Quesadillas', 'Tortas']
    },
    {
        name: 'Burger Bodega',
        category: 'food',
        subcategory: ['burgers'],
        badges: ['open late', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.770657527521593, -95.40715118568359],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/FjEU1lw.png',
        website: 'https://www.burgerbodega.com',
        blurb: 'Burgers and other comfort foods in a trendy space with a convenience-store theme and patio seating.',
        description: ['Chopped Cheese', 'Screwed Fries', 'Mango Lassi Shake']
    },
    {
        name: "Cabo Bob's Burritos",
        category: 'food',
        subcategory: ['burritos', 'tacos', 'salads'],
        badges: ['NFC mobile payments', 'drive thru', 'vegetarian options', 'alcohol available'],
        coordinates: [29.967527992522502, -95.5342163289566],
        neighborhood: 'Willowbrook',
        img: 'https://i.imgur.com/SaRnhvz.png',
        website: 'https://cabobobs.com',
        blurb: 'Casual chain serving Mexican eats such as burritos, tacos, nachos, and salads, plus breakfast.',
        description: ['Quesadillas', 'Nachos', 'Bowls']
    },
    {
        name: 'Seaside Poke',
        category: 'food',
        subcategory: ['poke'],
        badges: ['paid parking', 'NFC mobile payments', 'vegetarian options'],
        coordinates: [29.750070269208205, -95.3561589532907],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/hG24soA.png',
        website: 'https://www.seasidepoke.com',
        blurb: 'Bright, modern counter serve offering poke bowls customizable with various fish, veggies & sauces.',
        description: ['Spicy Tuna', 'Truffle Yellowtail', 'Tuna Aioli']
    },
    {
        name: 'Pokeworks',
        category: 'food',
        subcategory: ['poke', 'burritos'],
        badges: ['NFC mobile payments', 'vegetarian options'],
        coordinates: [29.77462490899634, -95.39817087004096],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/C47kr3D.png',
        website: 'https://pokeworks.com',
        blurb: 'Casual restaurant chain specializing in customizable Hawaiian poke bowls, burritos, and salads.',
        description: ['Spam Masubi', 'Poke Burritos', 'Spicyu Edamame']
    },
    {
        name: 'Poke Chef 2',
        category: 'food',
        subcategory: ['poke'],
        badges: ['NFC mobile payments'],
        coordinates: [29.936115082198054, -95.25019694109886],
        neighborhood: 'Humble',
        img: 'https://i.imgur.com/uFw7GG9.jpeg',
        website: 'https://www.pokechef.com',
        blurb: 'We specialize in crafting the most delicious handcrafted poke bowls in the Texas.',
        description: ['Signature Bowl', 'Skinny Girl', 'Fat Boy']
    },
    {
        name: 'Poke Chef',
        category: 'food',
        subcategory: ['poke'],
        badges: ['NFC mobile payments'],
        coordinates: [30.168923501868445, -95.45747439894737],
        neighborhood: 'The Woodlands',
        img: 'https://i.imgur.com/cgwaCwP.jpeg',
        website: 'https://www.pokechef.com',
        blurb: 'Casual Hawaiian restaurant specializing in create-your-own poke bowls with vegan options.',
        description: ['Signature Bowl', 'Skinny Girl', 'Fat Boy']
    },
    {
        name: 'Taqueria Abasolo',
        category: 'food',
        subcategory: ['tacos', 'breakfast'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.77782510920346, -95.35742602522896],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/FYbuaYo.png',
        website: 'https://www.yelp.com/biz/taqueria-abasolo-houston',
        blurb: 'Family-owned restaurant dishing up authentic Mexican eats such as breakfast tacos, enchiladas, and chilaquiles.',
        description: ['Fajita tacos', 'California burrito', 'Carne Asada']
    },
    {
        name: 'B&B Butchers & Restaurant',
        category: 'food',
        subcategory: ['upscale', 'steak', 'sandwiches', 'salads', 'breakfast', 'burgers', 'soup', 'pasta', 'seafood'],
        badges: ['NFC mobile payments', 'outdoor seating', 'alcohol available'],
        coordinates: [29.767973961851343, -95.3764358489442],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/AtinUW4.png',
        website: 'https://www.bbbutchers.com',
        blurb: 'A vintage bakery has been converted into an upscale steakhouse with an attached butcher shop & deli.',
        description: ['Reuben', 'Filet Mignon', 'Wasabi Crusted Tuna']
    },
    {
        name: 'Tornado Burger',
        category: 'food',
        subcategory: ['burgers'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.611432876791756, -95.56417582123774],
        neighborhood: 'Stafford',
        img: 'https://i.imgur.com/WqGl30h.png',
        website: 'http://tornadoburger.com',
        blurb: 'Mainstay for vast sandwich selection, including hamburgers, cheesesteaks & gyros amid casual decor.',
        description: ['Spicy Burgers', 'Loaded Fries', 'Steak Philly']
    },
    {
        name: 'Birria Queen',
        category: 'food',
        subcategory: ['tacos'],
        badges: ['NFC mobile payments', 'Vegetarian options'],
        coordinates: [29.730915406692098, -95.37640031478013],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/4hTpGpT.png',
        website: 'https://www.thebirriaqueen.com',
        blurb: 'Food truck dishing up crunchy beef and vegan birria tacos, plus ramen, and grilled cheese.',
        description: ['Tacos', 'Ramen', 'Churro by the Pound']
    },
    {
        name: 'milk + sugar',
        category: 'food',
        subcategory: ['dessert'],
        badges: ['NFC mobile payments'],
        coordinates: [29.74292224092003, -95.40688892103273],
        neighborhood: 'Hyde Park',
        img: 'https://i.imgur.com/bf1s8XZ.png',
        website: 'https://www.milkandsugarcreamery.com',
        blurb: 'Laid-back spot for handcrafted ice cream in creative flavors housed in a restored historic building.',
        description: ['Yum Cha', 'Ube', 'City that Never Sleeps']
    },
    {
        name: "Kenny & Ziggy's NY Deli",
        category: 'food',
        subcategory: ['sandwiches', 'hotdogs', 'salads', 'burgers', 'dessert'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.748259914154513, -95.45976396382343],
        neighborhood: 'Westside',
        img: 'https://i.imgur.com/Bko0CXd.png',
        website: 'https://www.kennyandziggys.com',
        blurb: 'Famous deli serving huge pastrami sandwiches & other classics in an old-school setting.',
        description: ['Bagels', 'Chicken Shawarma', 'Pies & Shakes']
    },
    {
        name: 'The Red Chickz',
        category: 'food',
        subcategory: ['chicken', 'salads', 'tacos', 'sandwiches'],
        coordinates: [29.9928026042872, -95.75046575857047],
        neighborhood: 'Cypress',
        img: 'https://i.imgur.com/6SEXCyu.jpeg',
        website: 'https://theredchickz.com',
        blurb: 'Casual restaurant dishing up Nashville hot chicken sandwiches, tenders, and other eats with comeback sauce.',
        description: ['$2 Tender Tuesdays', 'Hot Chicken', 'Comeback Sauce']
    },
    {
        name: 'burger-chan',
        category: 'food',
        subcategory: ['burgers', 'hotdogs'],
        badges: ['NFC mobile payments', 'outdoor seating', 'alcohol available'],
        coordinates: [29.737594198471, -95.46921303967943],
        neighborhood: 'Uptown',
        img: 'https://i.imgur.com/ZkKhxQL.jpeg',
        website: 'https://burgerchanhtx.com',
        blurb: "A highly-acclaimed burger restaurant in Houston serving highly customizable burgers that can be as simple or as complex as you'd like.",
        description: ['Customizable burgers', 'Falafael', 'Closes early']
    },
    {
        name: '88 DUMPLING HOUSE',
        category: 'food',
        subcategory: ['dumplings', 'soup'],
        coordinates: [29.692825649439687, -95.41423719051352],
        neighborhood: 'Astrodome Area',
        img: 'https://i.imgur.com/ch4BDAy.jpeg',
        website: 'https://88dumplinghouse.com',
        blurb: '88 Dumpling House serves both American and authentic Chinese dishes, as well as a selection of Southeast Asian specialties. Our menu features a variety of handcrafted dumplings made with the freshest ingredients and traditional cooking methods.',
        description: ['Soup Dumplings', 'Pan-Fried Buns', 'Wontons']
    },
    {
        name: 'Nobu Houston',
        category: 'food',
        subcategory: ['sushi', 'dessert'],
        badges: ['NFC mobile payments', 'vegetarian options', 'alcohol available'],
        coordinates: [29.73944796431526, -95.46553914495829],
        neighborhood: 'Galleria',
        img: 'https://i.imgur.com/6xzEMRN.png',
        website: 'https://www.noburestaurants.com/houston/home',
        blurb: "Iron Chef Nobu Matsuhisa's hot & cold Japanese delicacies served in spacious & posh surroundings.",
        description: ['$65 Buffet', 'Sake', 'Sushi']
    },
    {
        name: 'Hudson House',
        category: 'food',
        subcategory: ['upscale', 'seafood', 'salads'],
        badges: ['paid parking', 'alcohol available'],
        coordinates: [29.75345156819565, -95.40745527565623],
        neighborhood: 'River Oaks',
        img: 'https://i.imgur.com/Y3zcpvU.png',
        website: 'https://www.hudsonhousehp.com/Houston/',
        blurb: 'American restaurant in the River Oaks Shopping Center offering lobster rolls, oysters, and other seafood with cocktails.',
        description: ['Weekend Brunch', 'Lobster Roll', 'Key Lime Pie']
    },
    {
        name: 'Maine-ly Sandwiches',
        category: 'food',
        subcategory: ['seafood', 'sandwiches', 'soup'],
        badges: ['NFC mobile payments'],
        coordinates: [29.78562964964358, -95.4656246146352],
        neighborhood: 'Northwest Houston',
        img: 'https://i.imgur.com/YHSKRdm.png',
        website: 'https://mainelysandwiches.com',
        blurb: 'New England–style eatery serving lobster rolls, seafood sandwiches, chowder, and whoopie pies in a casual setting.',
        description: ['Chowder', 'Lobster Rolls', 'Whoopie Pies']
    },
    {
        name: 'Sushi Miyagi',
        category: 'food',
        subcategory: ['sushi', 'soup'],
        badges: ['NFC mobile payments', 'vegetarian options'],
        coordinates: [29.704877178262258, -95.56718028418902],
        neighborhood: 'Chinatown',
        img: 'https://i.imgur.com/rvBjey6.png',
        website: 'https://www.yelp.com/biz/sushi-miyagi-houston',
        blurb: 'Cozy eatery featuring sushi & classic Japanese cuisine in unpretentious environs with Asian decor.',
        description: ['Soba Noodles', 'Sushi', 'Combos']
    },
    {
        name: 'Hobbit Cafe',
        category: 'food',
        subcategory: ['sandwiches', 'burgers', 'soup', 'salads'],
        badges: ['NFC mobile payments', 'outdoor seating' ,'vegetarian options'],
        coordinates: [29.73365247547704, -95.41468893974502],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/pnYjKuX.png',
        website: 'https://hobbitcafehtx.com',
        blurb: 'Locally-loved eatery for sandwiches, burgers & vegetarian grub under a giant oak tree since 1972.',
        description: ['Fajita Nachos', 'Stuffed Jalapenos', 'Boudin Burger']
    },
    {
        name: 'Seoulside Wings & Rice',
        category: 'food',
        subcategory: ['chicken', 'ricebowl'],
        coordinates: [29.737595800185332, -95.4695061366912],
        neighborhood: 'Uptown',
        img: 'https://i.imgur.com/MRjaKDU.png',
        website: 'https://www.seoulsidewings.com',
        blurb: 'Houston gem offering crispy, house battered, Korean Style Wings, Rice Bowls, and Specialty Fries',
        description: ['Seoul Bowl', 'K Sauce WIngs', 'Starberry Lemonade']
    },
    {
        name: "Honeychild's Sweet Creams",
        category: 'food',
        subcategory: ['dessert'],
        badges: ['NFC mobile payments'],
        coordinates: [29.783084584294574, -95.4088695564218],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/imGmSbb.png',
        website: 'https://www.honeychildssweetcreams.com',
        blurb: 'Homemade frozen custards in seasonal flavors using locally sourced ingredients.',
        description: ['Cookies', 'Ice Cream', 'Blue Corn Cones']
    },
    {
        name: 'Tiny Boxwoods',
        category: 'food',
        subcategory: ['sandwiches', 'salads'],
        badges: ['NFC mobile payments', 'alcohol available', 'vegetarian options'],
        coordinates: [29.73843174689435, -95.43512274636153],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/MQxJoDI.png',
        website: 'https://tinyboxwoods.com',
        blurb: 'Upscale garden cafe with an open, airy vibe serving light fare & famed chocolate chip cookies.',
        description: ['Cheese Board', 'Bread Service', 'Sourdough Grilled Cheese']
    },
    {
        name: 'Loves Dumpling House',
        category: 'food',
        subcategory: ['dumplings'],
        badges: ['NFC mobile payments', 'vegetarian options'],
        coordinates: [29.741977848293004, -95.75228704780734],
        neighborhood: 'Cinco Ranch',
        img: 'https://i.imgur.com/lQz5Ho1.png',
        website: 'https://www.lovesdumplinghouse.com',
        blurb: "We hope that when you visit, you feel like you’re part of our family. At Love’s Dumpling House, every dish is crafted to bring a little warmth, comfort, and happiness to your day.",
        description: ['Soup Dumplings', 'Wontons', 'Pan-Fried Dumplings']
    },
    {
        name: 'Vinoteca Poscol',
        category: 'food',
        subcategory: ['upscale', 'pasta', 'salads'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.74470376976128, -95.38921432996437],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/6fjbUAQ.png',
        website: 'https://www.poscolhouston.com',
        blurb: 'Italian wines & small plates, including house-cured salumi, presented in an intimate atmosphere.',
        description: ['cafe', 'wine', 'small plates']
    },
        {
        name: "Perry's Steakhouse",
        category: 'food',
        subcategory: ['upscale', 'steak', 'salads', 'soup'],
        badges: ['NFC mobile payments', 'outdoor seating', 'vegetarian options', 'alcohol available'],
        coordinates: [29.752617169010016, -95.40815345397641],
        neighborhood: 'Hyde Park',
        img: 'https://i.imgur.com/fq7U2Ss.png',
        website: 'https://perryssteakhouse.com/locations/tx/houston/river-oaks/',
        blurb: 'Upscale steakhouse & grill serving a menu including chops, seafood, wine & cocktails.',
        description: ['Famous Pork Chop Specials', 'Diverse Menu', 'Steak']
    },
    {
        name: 'Tumble 22',
        category: 'food',
        subcategory: ['chicken'],
        badges: ['alcohol available'],
        coordinates: [29.767929129949536, -95.37261205901254],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/AYtw8kG.png',
        website: 'https://tumble22.com/houston-avenue/',
        blurb: 'All-natural chicken raised in Texas is served at this casual joint with cold beer and cocktails.',
        description: ['Pepper flavored heat', 'Fried Chicken', 'Salted Caramel Shake']
    },
    {
        name: 'Popfancy Dessert Bar',
        category: 'food',
        subcategory: ['dessert'],
        badges: ['NFC mobile payments'],
        coordinates: [29.704480743948015, -95.54950290064457],
        neighborhood: 'Chinatown',
        img: 'https://i.imgur.com/H2T7aRZ.png',
        website: 'https://www.popfancypops.com',
        blurb: 'Dessert spot with anime and pop-culture themes serving imaginative frozen treats and drinks.',
        description: ['Special Popsicles', 'Ice Cream Swirls', 'Hot Mochi Waffle Pops']
    },
    {
        name: 'Red Circle',
        category: 'food',
        subcategory: ['dessert'],
        badges: ['NFC mobile payments'],
        coordinates: [29.70562194424755, -95.54617168362007],
        neighborhood: 'Chinatown',
        img: 'https://i.imgur.com/MinkMxA.png',
        website: 'https://www.redcirclefranchising.com',
        blurb: 'Laid-back parlor serving creatively topped ice cream cones & sandwiches, plus heart-shaped churros.',
        description: ['Elmo Crunch', 'Ice Cream Filled Macaron', 'Home of the Original Churro Daddy']
    },
    {
        name: "George's Bistro & Bar",
        category: 'food',
        subcategory: ['upscale', 'pasta', 'salad', 'soup', 'pizza', 'steak'],
        badges: ['NFC mobile payments', 'outdoor seating'],
        coordinates: [29.725063849172606, -95.42097561707486],
        neighborhood: 'West University Place',
        img: 'https://i.imgur.com/LfCsngL.png',
        website: 'https://www.georgesbistroandbar.com',
        blurb: 'Wine and cocktails accompany a menu of American fare at this informal restaurant with a patio.',
        description: ['Pasta', 'Patio', 'Salads']
    },
    {
        name: 'Chicago Wings and Things',
        category: 'food',
        subcategory: ['chicken', 'seafood'],
        coordinates: [29.902013689935224, -95.34328017833938],
        neighborhood: 'East Aldine',
        img: 'https://i.imgur.com/95nnVyi.png',
        website: 'https://chicago-wings-things.square.site',
        blurb: 'The New Wing King in Texas',
        description: ['10 for $10', 'Chicken and Waffles', 'Shrimp Sauce']
    },
    {
        name: 'Texas Hamburger Palace',
        category: 'food',
        subcategory: ['burgers', 'seafood'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.718405512072497, -95.54838025074939],
        neighborhood: 'Chinatown',
        img: 'https://i.imgur.com/d3vCOcu.png',
        website: 'https://www.facebook.com/people/Texas-Hamburger-Palace/100054674190103/',
        blurb: 'A variety of burgers & fried sides are served at this Southern-flavored spot with down-home decor.',
        description: ['Blackened Fish Sandwich', 'Onion Rings', 'Spicy Fries']
    },
    {
        name: 'Wagyuru',
        category: 'food',
        subcategory: ['burgers'],
        badges: ['NFC Mobile Payments'],
        coordinates: [29.705080819289968, -95.47082361097749],
        neighborhood: 'Bellaire',
        img: 'https://i.imgur.com/YB0V8B8.png',
        website: 'https://www.wagyuru.com',
        blurb: "At WAGYURU, our passion extends beyond simply offering premium products; we are deeply invested in our customers' experiences and in supporting the hardworking ranches of Texas.",
        description: ['Sat & Sun Only', 'Wagyu Burgers', 'Meat Market']
    },
    {
        name: 'The Better Box',
        category: 'food',
        subcategory: 'sandwiches',
        badges: ['NFC mobile payments'],
        coordinates: [29.92454002353021, -95.55595644825505],
        neighborhood: 'Jersey Village',
        img: 'https://i.imgur.com/9x790DS.png',
        website: 'https://www.instagram.com/thebetterboxllc/?hl=en',
        blurb: 'Philly Food Truck 😎 Now in Houston',
        description: ['Loaded Seafood Fries', 'Philly Cheesesteak', 'Fried Eggrolls']
    },
    {
        name: "Antonini's Subs",
        category: 'food',
        subcategory: ['sandwiches'],
        badges: ['NFC mobile payments'],
        coordinates: [29.54211857437588, -95.1234131409383],
        neighborhood: 'Webster',
        img: 'https://i.imgur.com/fZAPgBg.png',
        website: 'https://www.yelp.com/biz/antoninis-subs-and-steaks-webster',
        blurb: 'Casual family-owned counter serve offering burgers, cheesesteaks, hoagies & other sandwiches.',
        description: ['Italian Sub', 'Philly Cheese Steak', 'Meatball Sub']
    },  
    // Bars
    {
        name: 'Axelrad',
        category: 'bar',
        badges: ['paid parking', 'alcohol available', 'live music', 'outdoor seating', 'photogenic'],
        coordinates: [29.734989085866363, -95.37481472963191],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/RKS2yyq.png',
        website: 'https://www.axelradhouston.com/?utm_source=local&utm_medium=organic&utm_campaign=gmb',
        blurb: 'Craft beers galore offered in a laid-back outdoor setup with hammocks, food trucks & regular events.',
        description: ['Concerts', 'Hammocks', 'Food trucks']
    },
    {
        name: 'Betelgeuse Betelgeuse',
        category: 'bar',
        subcategory: ['pizza'],
        badges: ['open late', 'outdoor seating', 'alcohol available'],
        coordinates: [29.767873715445898, -95.37960345473097],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/3EB93eb.png',
        website: 'https://www.betelgeusehou.com/',
        blurb: 'Betelgeuse Betelgeuse is a neighborhood cocktail bar with pizza and snacks',
        description: ['Pizza', 'Full bar', 'Outdoor seating']
    },
    {
        name: 'Betelgeuse Betelgeuse',
        category: 'bar',
        subcategory: ['pizza'],
        badges: ['open late', 'outdoor seating', 'alcohol available'],
        coordinates: [29.73385004922882, -95.3868317708331],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/xuiw7Ya.png',
        website: 'https://www.betelgeusehou.com/',
        blurb: 'Betelgeuse Betelgeuse is a neighborhood cocktail bar with pizza and snacks',
        description: ['Pizza', 'Full bar', 'Outdoor seating']
    },
    {
        name: 'Lost & Found',
        category: 'bar',
        subcategory: ['seafood', 'crawfish'],
        badges: ['black owned', 'open late', 'outdoor seating', 'alcohol available', 'hookah', 'paid parking'],
        coordinates: [29.75348220171603, -95.38091870436139],
        neighborhood: 'Fourth Ward',
        img: 'https://i.imgur.com/P657VXU.png',
        website: 'https://lostandfoundmidtown.com/',
        blurb: 'Relaxed restaurant offering cocktails, brunch & mains, plus patio dining with views of midtown.',
        description: ['Happy hour', 'Outdoor seating', 'Hookah']
    },
    {
        name: "A'dor",
        category: 'bar',
        subcategory: ['crawfish'],
        badges: ['open late', 'outdoor seating', 'alcohol available', 'hookah', 'DJ', 'live music', 'paid parking'],
        coordinates: [29.753411079893684, -95.38650062691997],
        neighborhood: 'Fourth Ward',
        img: 'https://i.imgur.com/JTsWFwL.png',
        website: 'https://adorhouston.com/',
        blurb: 'Bohemian joint with live music & a terrace serving pizzas, burgers & wings, plus cocktails.',
        description: ['Happy hour', 'Hookah', 'Daiquiris']
    },
    {
        name: 'CRU',
        category: 'bar',
        badges: ['black owned', 'open late', 'alcohol available', 'hookah', 'DJ'],
        coordinates: [29.762292281329156, -95.3616406517955],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/crlJaYk.png',
        website: 'https://crulounge.com/',
        blurb: 'Casual bar with a neon-lit vibe offering small plates & cocktails, plus hookah pipes.',
        description: ['Neon lit', 'Hookah', 'DJ']
    },
    {
        name: 'CRU',
        category: 'bar',
        badges: ['black owned', 'open late', 'alcohol available', 'hookah', 'DJ'],
        coordinates: [29.7162290256621, -95.49744793118549],
        neighborhood: 'Galleria',
        img: 'https://i.imgur.com/TlPjazB.png',
        website: 'https://crulounge.com/',
        blurb: 'Casual bar with a neon-lit vibe offering small plates & cocktails, plus hookah pipes.',
        description: ['Neon lit', 'Hookah', 'DJ']
    },
    {
        name: 'Heights Bier Garten',
        category: 'bar',
        badges: ['open late', 'alcohol available', 'outdoor seating', 'dog friendly'],
        coordinates: [29.797314935102868, -95.41030956614523],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/5IAvJoV.png',
        website: 'https://www.heightsbiergarten.com/',
        blurb: 'Craft beer garden offering cocktails, wine, bar food, and a pet-friendly patio with fire pits.',
        description: ['Beer list', 'Outdoor seating', 'Soft pretzel']
    },
    {
        name: 'Locker Room',
        category: 'bar',
        subcategory: ['crawfish'],
        badges: ['black owned', 'open late', 'alcohol available', 'hookah', 'outdoor seating'],
        coordinates: [29.72193649943075, -95.36747176543562],
        neighborhood: 'South Side',
        img: 'https://i.imgur.com/1MXxNyt.png',
        website: 'https://www.google.com/search?q=locker+room+houston+bar&oq=locker+room+houston+bar&gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7MhYIARAuGK8BGMcBGJECGIAEGIoFGI4FMg0IAhAAGJECGIAEGIoFMggIAxAAGBYYHjIICAQQABgWGB4yCAgFEAAYFhgeMggIBhAAGBYYHjIICAcQABgWGB4yCAgIEAAYFhge0gEIMzQzMWoxajSoAgCwAgE&sourceid=chrome&ie=UTF-8',
        blurb: 'Casual bar and grill featuring comfort food, happy hours, and sports on TV, plus a patio.',
        description: ['Happy hour', 'Hookah', 'Shots']
    },
    {
        name: 'Saint Arnold Brewing Company',
        category: 'bar',
        badges: ['open late', 'alcohol available', 'outdoor seating'],
        coordinates: [29.771212770697776, -95.34753793820126],
        neighborhood: 'Greater Fifth Ward',
        img: 'https://i.imgur.com/qkG3Lm3.png',
        website: 'https://www.saintarnold.com/',
        blurb: 'Established craft brewery featuring facility tours & a beer hall serving pints & pub grub for lunch.',
        description: ['Houston Brewing', 'Cider List', 'Outdoor Seating']
    },
    {
        name: "Warren's Inn",
        category: 'bar',
        badges: ['open late', 'alcohol available'],
        coordinates: [29.76239315781994, -95.36150769972693],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/6eqneAi.png',
        website: 'https://www.google.com/search?q=warrens+houston&oq=warrens+houston&gs_lcrp=EgZjaHJvbWUqCggAEAAY4wIYgAQyCggAEAAY4wIYgAQyEAgBEC4YrwEYxwEYgAQYjgUyCAgCEAAYFhgeMggIAxAAGBYYHjIICAQQABgWGB4yCAgFEAAYFhgeMggIBhAAGBYYHjIICAcQABgWGB4yCAgIEAAYFhgeMggICRAAGBYYHtIBCDQzNDJqMWo0qAIAsAIB&sourceid=chrome&ie=UTF-8',
        blurb: 'Drinks are served at this easygoing dive bar, which has a jukebox.',
        description: ['Historic bar', 'Friendly staff', 'Tavern feel']
    },
    {
        name: 'Cidercade',
        category: 'bar',
        badges: ['open late', 'alcohol available'],
        coordinates: [29.7574399740177, -95.34675785219966],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/8JVJfkN.png',
        website: 'https://cidercade.com/houston/',
        blurb: 'Huge arcade bar with a mix of classic & modern games, plus house-made hard ciders',
        description: ['Free parking', 'Unlimited arcade', 'Cider flights']
    },
    {
        name: 'Houston Watch Company',
        category: 'bar',
        badges: ['open late', 'alcohol available'],
        coordinates: [29.763506399996455, -95.36059241953069],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/nT6Kd5H.png',
        website: 'https://www.houstonwatchcompany.com/',
        blurb: 'This former watch shop is now a quaint, 2-level cocktail bar in the lobby of the Bayou Lofts.',
        description: ['Historic', 'Quiet seating', 'Second floor']
    },
    {
        name: 'Behind Closed Doors',
        category: 'bar',
        badges: ['open late', 'alcohol available'],
        coordinates: [29.761971390805527, -95.3611870578859],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/uyHPLGM.png',
        website: 'https://bcd-htx.com/',
        blurb: 'Trendy bar featuring a hidden speakeasy with music and dancing.',
        description: ['Secret spaces', 'Old Hollywood Speakeasy', 'R&B Speakeasy']
    },
    {
        name: 'Cherry',
        category: 'bar',
        badges: ['open late', 'alcohol available', 'photogenic'],
        coordinates: [29.762068172596784, -95.3611910729658],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/OxYv0nj.png',
        website: 'https://cherryhtx.com',
        blurb: 'Trendy nightclub with a packed dance floor featuring retro music and cocktails.',
        description: ['Trendy', 'Full bar', 'Walkable Area']
    },
    {
        name: 'Notsuoh',
        category: 'bar',
        badges: ['open late', 'alcohol available', 'photogenic'],
        coordinates: [29.761835136484965, -95.3612382178252],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/BJuiv6f.png',
        website: 'https://notsuoh.com',
        blurb: 'Quirky watering hole ofering poetry readings, live music & performing artists with a funky vibe.',
        description: ['Trendy', 'Full bar', 'Walkable Area']
    },
    {
        name: 'Ladybirds',
        category: 'bar',
        badges: ['open late', 'outdoor seating', 'alcohol available'],
        coordinates: [29.77476119202706, -95.41842694823647],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/IOnQn4G.png',
        website: 'https://ladybirdsbar.com',
        blurb: 'Family-owned watering hole offering craft brews & specialty cocktails, plus a spacious patio.',
        description: ['Outdoor Seating', 'Casual', 'Beer and Cocktails']
    },
    {
        name: 'Sugar Room',
        category: 'bar',
        badges: ['open late', 'paid parking', 'outdoor seating', 'alcohol available', 'DJ'],
        coordinates: [29.770604569930263, -95.41329371711167],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/C80jglX.png',
        website: 'https://www.instagram.com/sugarroomhtx/?hl=en',
        blurb: 'An Upscale Speakeasy An innuendo to Prohibition days past, Sugar Room is a hidden speakeasy-inspired bar located in the heart of Houston’s bustling nightlife scene. Enjoy hand-crafted cocktails cocktails in our upscale lounge, or move the party to our outdoor patio with 2,000 square feet of space for socializing.',
        description: ['Speakeasy', 'Cocktails', 'DJ Nights']
    },
    {
        name: 'Pitch 25',
        category: 'bar',
        badges: ['open late', 'paid parking', 'alcohol available'],
        coordinates: [29.751557482444884, -95.35468225434623],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/pL05Sc6.png',
        website: 'https://www.facebook.com/pitch25beerpark/menu/',
        blurb: 'Pub grub & nearly 100 draft beers in a cool, cavernous warehouse with games & lots of outdoor seats.',
        description: ['Sports bar', 'Dodgeball', 'Axe throwing']
    },
    {
        name: 'Tejas Brewery',
        category: 'bar',
        badges: ['open late', 'outdoor seating', 'alcohol available', 'photogenic'],
        coordinates: [29.772552031946326, -95.37956184665045],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/Kpw0cYz.png',
        website: 'https://tejasbeer.com',
        blurb: 'Tejas Brewery is located in the heart of vibrant Sawyer Yards, offering three stories of exceptional food, handcrafted beer, creative cocktails, artisan coffee, and versatile event spaces—all with a stunning view of downtown Houston.',
        description: ['View of skyline', 'Outdoor seating', 'Full menu']
    },
    {
        name: 'Postino',
        category: 'bar',
        subcategory: ['sandwiches'],
        badges: ['open late', 'outdoor seating', 'alcohol available'],
        coordinates: [29.782984392258367, -95.39855598565903],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/VOeVq1m.png',
        website: 'https://www.postinowinecafe.com/locations/postino-heights',
        blurb: 'Hip chain in a modern-chic sapce, specializing in Italian favorites and specialty bruschetta, plus wine.',
        description: ['Classy', 'Wine bar', 'Full menu']
    },
    {
        name: 'Postino',
        category: 'bar',
        subcategory: ['sandwiches'],
        badges: ['open late', 'outdoor seating', 'alcohol available'],
        coordinates: [29.746522189697743, -95.39033692975383],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/AfbB55w.png',
        website: 'https://www.postinowinecafe.com/locations/postino-montrose',
        blurb: 'Hip chain in a modern-chic sapce, specializing in Italian favorites and specialty bruschetta, plus wine.',
        description: ['Classy', 'Wine bar', 'Full menu']
    },
    {
        name: 'Postino',
        category: 'bar',
        subcategory: ['sandwiches'],
        badges: ['open late', 'outdoor seating', 'alcohol available'],
        coordinates: [29.75432446959847, -95.45728990091776],
        neighborhood: 'Uptown',
        img: 'https://i.imgur.com/wajbCUB.png',
        website: 'https://www.postinowinecafe.com/locations/postino-uptown-park',
        blurb: 'Hip chain in a modern-chic sapce, specializing in Italian favorites and specialty bruschetta, plus wine.',
        description: ['Classy', 'Wine bar', 'Full menu']
    },
    {
        name: "Neighbors",
        category: 'bar',
        subcategory: ['pizza'],
        badges: ['open late', 'outdoor seating', 'alcohol available', 'live music'],
        coordinates: [29.748317085532182, -95.34099179797487],
        neighborhood: 'Second Ward',
        img: 'https://i.imgur.com/HwOUYHs.png',
        website: 'https://www.neighborspizzabar.com',
        blurb: 'Neighborhood bar offering beer, cocktails, and wine, plus live entertainment and games.',
        description: ['Live music', 'Card games', 'Outdoor seating']
    },
    {
        name: "Jethro's Cocktail Lounge",
        category: 'bar',
        subcategory: ['burgers'],
        badges: ['open late', 'alcohol available', 'outdoor seating'],
        coordinates: [29.748620029553102, -95.38363990559155],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/plw9xXM.png',
        website: 'https://www.jethroshouston.com',
        blurb: 'Casual, neighborhood cocktail lounge serving beer, wine, spirits, and espresso martinis.',
        description: ['Happy Hour Burgers', 'Full Bar', 'Relaxing Atmosphere']
    },
    {
        name: 'The Art Room HTX',
        category: 'bar',    
        badges: ['black owned', 'open late', 'hookah', 'alcohol available', 'live music'],
        coordinates: [29.7222807494074, -95.37865293968716],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/pR8oSA9.png',
        website: 'https://artroomcafe.wordpress.com',
        blurb: 'Local Cafe for us to vibe, work, eat, and meet.',
        description: ['Hookah', 'Poetry', 'Live Music']
    },
    {
        name: 'Bad Astronaut',
        category: 'bar',
        badges: ['open late', 'outdoor seating', 'alcohol available'],
        coordinates: [29.77382898968824, -95.35642157871743],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/3krCSVs.png',
        website: 'https://badastronautbeer.com',
        blurb: 'Chill brewpub offering live music, as well as bar games such as air hockey, pool, and foosball.',
        description: ['Events', 'Drinks', 'Seltzers']
    },
    {
        name: 'LOV3 Houston',
        category: 'bar',
        badges: ['open late', 'alcohol available', 'hookah', 'DJ', 'live music'],
        coordinates: [29.743772099614706, -95.37712392834055],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/w0bFP5h.png',
        website: 'https://www.lov3htx.com',
        blurb: 'Bar serving global fare alongside hookahs, cocktails, and live entertainment.',
        description: ['Daily Events', ' Live Music', 'Happy Hour']
    },
    {
        name: 'Melrose',
        category: 'bar',
        badges: ['open late', 'paid parking', 'alcohol available'],
        coordinates: [29.743234981473602, -95.40106372780808],
        neighborhood: 'Hyde Park',
        img: 'https://i.imgur.com/WfPjlro.png',
        website: 'https://www.melrosehtx.com',
        blurb: "Upscale cocktail lounge in Houston's Montrose neighborhood, offering a curated selection of seasonal cocktails and elevated bar bites in a chic, sensory-rich setting.",
        description: ['Intimate', 'Cocktails', "Espresso 'Tini"]
    },
    {
        name: 'Sixes and Sevens',
        category: 'bar',
        badges: ['open late', 'outdoor seating', 'alcohol available', 'DJ'],
        coordinates: [29.7499426960642, -95.39667766947576],
        neighborhood: 'Hyde Park',
        img: 'https://i.imgur.com/H8UiGPG.png',
        website: 'https://www.sixesandsevenshtx.com',
        blurb: 'Local cocktail lounge with outdoor seating.',
        description: ['Live Music', 'Full Bar', 'Intimate']
    },
    {
        name: 'Bald Kity',
        category: 'bar',
        badges: ['open late', 'alcohol available', 'DJ'],
        coordinates: [29.769105737978585, -95.35636272826707],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/2EQ1Hhq.png',
        website: 'https://www.instagram.com/baldkittyhouston/?hl=en',
        blurb: 'A design-focused space for live jazz, Latin nights, DJs, curated art and great company.',
        description: ['Live DJ', 'Events', 'Cover']
    },
    {
        name: 'Scout Bar',
        category: 'bar',
        badges: ['open late', 'alcohol available', 'live music'],
        coordinates: [29.543920868577192, -95.10339494749947],
        neighborhood: 'Webster',
        img: 'https://i.imgur.com/bY23PCi.png',
        website: 'https://scoutbar.com',
        blurb: "Rockin' spot for loud live music & drinks featuring 2 bars & separate room with a DJ & dance floor.",
        description: ['Rock Bar', 'Stage', 'Events']
    },
    {
        name: 'Yard House',
        category: 'bar',
        subcategory: ['burgers', 'sandwiches'],
        badges: ['open late', 'paid parking', 'NFC mobile payments', 'outdoor seating', 'alcohol available'],
        coordinates: [29.77997937306853, -95.56129257515006],
        neighborhood: 'CityCentre',
        img: 'https://i.imgur.com/W0n320h.png',
        website: 'https://www.yardhouse.com/home',
        blurb: 'High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.',
        description: ['Sports Bar', 'Pizzas', 'Appetizers']
    },
    {
        name: 'Chapman & Kirby',
        category: 'bar',
        badges: ['paid parking', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.75031619530131, -95.35603401249799],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/K5BPn2L.png',
        website: 'https://www.chapmanandkirby.com',
        blurb: 'Sprawling, retro-chic American gastropub & nightlife spot offering creative cocktails & local beer.',
        description: ['Sunday Brunch', 'Wine', 'Cocktails']
    },
    {
        name: "Rabbit's Got the Gun",
        category: 'bar',
        subcategory: ['crawfish'],
        badgess: ['open late', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.776389024727287, -95.36012911444952],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/sPNH1iL.png',
        website: 'https://www.instagram.com/rabbitsgotthegunhtx/?hl=en',
        blurb: 'Compact spot with a lively ambiance offering beer & fancy mixed drinks, plus an on-site taco truck.',
        description: ['Drinks', 'Deals', 'Crawfish']
    },
    {
        name: 'Clarkwood',
        category: 'bar',
        badges: ['open late', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.759952946483985, -95.39922771086621],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/Qh5wGbV.png',
        website: 'https://www.clarkwoodhtx.com',
        blurb: 'Elegant cocktail bar for wines and classic libations in a historic theater.',
        description: ['Elegant bar', 'Espresso Martini', 'Old Fashioned']
    },
    {
        name: "93' Til",
        category: 'bar',
        badges: ['NFC mobile payments', 'outdoor seating', 'alcohol available'],
        coordinates: [29.73572893007341, -95.39948453521131],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/hFvVbA2.png',
        website: 'https://93-til.com',
        blurb: 'Refined homestyle fare & cocktails in a laid-back restaurant that has warm decor & vinyl records.',
        description: ['Brunch', 'Happy Hour', 'Wine & Spirits']
    },
    {
        name: 'The Davenport',
        category: 'bar',
        badges: ['open late', 'NFC mobile payments', 'alcohol available', 'DJ'],
        coordinates: [29.73403676798527, -95.41130191573744],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/yV6Em4d.png',
        website: 'https://www.thedavenportlounge.com',
        blurb: 'Stylish lounge features 30+ specialty martinis, cocktails & regular DJ nights in a modern interior.',
        description: ['Martinis', 'Cocktails', 'Classics']
    },
    {
        name: 'Trash Panda',
        category: 'bar',
        badges: ['open late', 'NFC mobile payments', 'outdoor seating', 'alcohol available'],
        coordinates: [29.79839642467369, -95.36305367556504],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/lRl7gNI.png',
        website: 'https://www.trashpandahtx.com',
        blurb: 'Casual cocktail bar fixing up inventive drinks alongside pizza, tacos, and brunch.',
        description: ['$1 Wing Mondays', '$1 Taco Tuesdays', 'Cocktails']
    },
    {
        name: 'Aperitivo',
        category: 'bar',
        badges: ['alcohol available'],
        coordinates: [29.762349009142678, -95.34029796808532],
        neighborhood: 'Greater Fifth Ward',
        img: 'https://i.imgur.com/9znpoKm.png',
        website: 'https://aperitivohouston.com',
        blurb: 'Aperitivo is a stylish rooftop bar featuring a 5,000-square-foot indoor/outdoor patio. Offering a modern and inviting ambiance, Aperitivo is ideal happy hours, cocktail receptions, after-parties, and intimate gatherings.',
        description: ['Rooftop bar', 'Wine by the bottle', 'Difficult parking']
    },
    {
        name: 'Prospect Park',
        category: 'bar',
        subcategory: ['seafood'],
        badges: ['black owned', 'open late', 'NFC mobile payments', 'outdoor seating', 'alcohol available', 'live music'],
        coordinates: [29.7327169652465, -95.48464669727326],
        neighborhood: 'Mid West',
        img: 'https://i.imgur.com/fndo4t9.png',
        website: 'https://prospectparkrestaurants.com',
        blurb: 'Chill sports bar serving traditional American bar fare & brunch with drink specials, TVs & a patio.',
        description: ['Happy hour', 'Platters', 'Drinks']
    },
        {
        name: 'The Library',
        category: 'bar',
        subcategory: ['salads'],
        badges: ['open late', 'NFC mobile payments', 'alcohol available'],
        coordinates: [29.80334110269605, -95.49749811048325],
        neighborhood: 'Northwest Houston',
        img: 'https://i.imgur.com/BlyesfY.png',
        website: 'https://www.thelibraryhtx.com',
        blurb: 'The Library is a neighborhood wine bar located in Spring Branch. In our casual and cozy atmosphere, our guests can enjoy one of our many wines by the glass or choose something special from our bottle list, which features over 1,200 unique wines.',
        description: ['Library themed', 'Lots of wine', 'Cheese boards']
    },
    {
        name: 'The Flat',
        category: 'bar',
        subcategory: ['pizza'],
        badges: ['open late', 'outdoor seating', 'alcohol available', 'DJ'],
        coordinates: [29.75155536231054, -95.39869225451687],
        neighborhood: 'Hyde Park',
        img: 'https://i.imgur.com/wcBHQSc.png',
        website: 'https://www.theflathouston.com',
        blurb: 'Funky, no-frills nightspot with celebrated DJs, a chill lounge area & bar fare in a converted house.',
        description: ['Live Music', 'Drinks', 'Pizza']
    },
    {
        name: 'Platypus Brewing',
        category: 'bar',
        subcategory: ['steak'],
        badges: ['NFC mobile payments', 'outdoor seating' , 'alcohol available'],
        coordinates: [29.768406917178908, -95.37736164116566],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/DA7keco.png',
        website: 'https://www.platypusbrewing.com',
        blurb: 'Brewery taproom serving craft beer & Australian-inspired comfort food in cozy digs with a patio.',
        description: ["Fish 'n Chips", 'Wedenesday Steak Night $22.95', 'Happy Hour M-F 3-6pm']
    },
    {
        name: 'Zen Lounge',
        category: 'bar',
        badges: ['paid parking', 'outdoor seating', 'alcohol available', 'hookah'],
        coordinates: [29.770822567612857, -95.41553272831742],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/uxc8KI9.png',
        website: 'https://www.instagram.com/thezenloungehtx/',
        blurb: 'The perfect escape - great bites, strong cocktails, inside and outside patio seating. 420 friendly. ',
        description: ['Happy hour', 'Cocktails', 'Wings']
    },
    {
        name: 'Roots',
        category: 'bar',
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.741695974260452, -95.3500770864142],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/nMFOPwy.png',
        website: 'https://www.rootswinesbar.com',
        blurb: 'Easygoing hangout with a patio & a contemporary vibe offering creative cuisine & self-serve wine.',
        description: ['Automated Wine Bar', 'Small Bites', 'Vinyl Listening Rooms']
    },
    {
        name: 'City Cellers',
        category: 'bar',
        subcategory: ['sandwiches', 'soup', 'salads'],
        badges: ['alcohol available'],
        coordinates: [29.761957013339586, -95.34096665582909],
        neighborhood: 'Greater Fifth Ward',
        img: 'https://i.imgur.com/vQul9as.png',
        website: 'https://citycellarshtx.com',
        blurb: "Experience a decadent array of Southern-inspired and global cuisine in a stunning showcase of Houston's culinary and design excellence.",
        description: ['Great View of Skyline', 'Elote Creamed Corn', 'Umami Burger']
    },
    // Bookstores & Libraries
    {
        name: "Becker's Books",
        category: 'books',
        coordinates: [29.794251635722954, -95.47768854366207],
        neighborhood: 'Northwest Houston',
        img: 'https://i.imgur.com/7Tc5Kuc.png',
        website: 'https://www.beckersbooks.com/',
        blurb: 'Cozy family shop in a 3,5000-sq.-ft renovated house offers diverse used, rare & out-of-print books.',
        description: ['Renonvated House', 'Friendly Staff & Pets', 'Maze of used books']
    },
    {
        name: 'Kaboom Books',
        category: 'books',
        coordinates: [29.786977712444614, -95.37189190882646],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/qIspkWO.png',
        website: 'https://kaboombooks.com/',
        blurb: 'Homey shop featuring pre-owned books, including hard-to-find titles, also hosts events on its patio.',
        description: ['Walkable Area', 'Events', 'Outside Patio'],
    },
    {
        name: 'Murder By The Book',
        category: 'books',
        coordinates: [29.725750721718644, -95.41452430314608],
        neighborhood: 'University Place',
        img: 'https://i.imgur.com/vINmybd.png',
        website: 'https://murderbooks.com',
        blurb: 'Bookstore featuring new & used mystery novels, magazines, & collectibles also hosts author events.',
        description: ['Walkable Area', 'Mystery Section', 'Collectibles']
    },
    {
        name: 'Quarter Price Books',
        category: 'books',
        coordinates: [29.731932134424735, -95.41079697391432],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/riQzvW6.png',
        website: 'https://www.yelp.com/biz/1-4-price-books-houston-2',
        blurb: 'Organized store offering used and collectible books, plus many titles on Texas history.',
        description: ['Affordable Books', 'Walkable Area', 'First Editions']
    },
    {
        name: 'Kinokuniya',
        category: 'books',
        coordinates: [29.7889472043791, -95.77308058127569],
        neighborhood: 'Katy',
        img: 'https://i.imgur.com/XsqHn2C.png',
        website: 'https://usa.kinokuniya.com/stores-kinokuniya-katy',
        blurb: 'Japanese-based retailer known for its collection of Asian books & magazines.',
        description: ['Stationery', 'Fountain Pens', 'Book Nooks'],
    },
    {
        name: 'Lanier Theological Library',
        category: 'books',
        coordinates: [29.977528244026878, -95.54897270621879],
        neighborhood: 'Willowbrook',
        img: 'https://i.imgur.com/v8Pmeg7.png',
        website: 'https://lanierlibraryandlearningcenter.org',
        blurb: 'Lanier Theological Library is a 17,000 sq. ft non-circulating research library located in northwest Houston, Texas. It was built by Mark Lanier, who has taught Sunday school at Champion Forest Baptist Church for more than 20 years, and is part of his 35-acre estate.',
        description: ['Photogenic', 'Religious Library', 'Castle-like']
    },
    {
        name: 'Houston Public Library',
        category: 'books',
        coordinates: [29.759442236774625, -95.36996502172211],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/QsaagUi.png',
        website: 'https://houstonlibrary.org/home',
        blurb: 'Public library offering books, computers, and passport applications, plus a parking garage.',
        description: ['Downtown', 'Banned Books Section', 'Tech Equipment Available']
    },
    {
        name: 'TECHLink Dixon',
        category: 'books',
        coordinates: [29.833382192599448, -95.3287627739861],
        neighborhood: 'Houston Gardens',
        img: 'https://i.imgur.com/Kd2whMY.png',
        website: 'https://houstonlibrary.org/techlink',
        blurb: 'Public library featuring resources for learning such as a music studio.',
        description: ['Library', 'Music Studio', 'Computer Equipment']
    },
    {
        name: 'Hearsay',
        category: 'bar',
        badges: ['alcohol available', 'dog friendly'],
        coordinates: [29.732463633934497, -95.42238722635899],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/2zPxSNS.png',
        website: 'https://hearsaygastrolounge.com/reservations-hearsay/#levy-park',
        blurb: 'Chic destination for brunch, dinner, and small plates in an antique-filled space with a pet-friendly patio.',
        description: ['Cocktails', 'Dog Friendly', 'Located in Levy Park']
    },
    // Coffee Shops
    {
        name: 'Campesino Coffee House',
        category: 'coffee',
        badges: ['outdoor seating'],
        coordinates: [29.745984548960436, -95.39419752711699],
        neighborhood: 'Hyde Park',
        img: 'https://i.imgur.com/3Auw5wb.png',
        website: 'https://www.instagram.com/campesinocoffee1/?hl=en',
        blurb: 'Modern, stylish cafe serving coffee & Latin American specialty drinks, plus empanadas & sandwiches.',
        description: ['Cuban Coffee', 'Tamales', 'Empanadas']
    },
    {
        name: 'Chicha San Chen',
        category: 'coffee',
        badges: ['michelin rated'],
        coordinates: [29.705427281762052, -95.55272318332219],
        neighborhood: 'Chinatown',
        img: 'https://i.imgur.com/S9Wr6rg.png',
        website: 'https://www.instagram.com/chichasanchen.tx/?hl=en',
        blurb: "Michelin recommended boba shop in Houston's Chinatown",
        description: ['Michelin Recommended', 'Bubble Milk Tea', 'Sugar Levels']
    },
    {
        name: 'La La Land Kind Coffee',
        category: 'coffee',
        badges: ['outdoor seating', 'photogenic'],
        coordinates: [29.78216306202337, -95.40822417541648],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/kOi6K5h.png',
        website: 'https://lalalandkindcafe.com/pages/mkt-shepherd',
        blurb: 'Trendy cafe known for its matcha drinks and avocado toast, plus an emphasis on kindness.',
        description: ['Walkable area', 'Yellow', 'Coffee']
    },
    {
        name: 'Luce Coffee Roasters',
        category: 'coffee',
        coordinates: [29.816500709021927, -95.42918113240202],
        neighborhood: 'Oak Forest',
        img: 'https://i.imgur.com/aFa0Ekd.png',
        website: 'https://www.instagram.com/lucecoffeeroasters/',
        blurb: "Specialty coffee shop and roastery for espresso drinks, tea, breakfast tacos, pastries, and a kids' menu.",
        description: ['Coffee', 'Events', 'Walkable area']
    },
    {
        name: 'HTeaO',
        category: 'coffee',
        badges: ['drive thru'],
        coordinates: [30.092839580594955, -95.62470622095695],
        neighborhood: 'Tomball',
        img: 'https://i.imgur.com/fVLyiQA.png',
        website: 'https://hteao.com/locations/tomball-tx/',
        blurb: 'Chain tea shop offering an array of iced tea flavors and crushed or cubed ice.',
        description: ['Samples', 'Dog Treats', 'Texasi Chai']
    },
    {
        name: 'The Boba Shop',
        category: 'coffee',
        coordinates: [30.072344295099644, -95.43639807164976],
        neighborhood: 'Spring',
        img: 'https://i.imgur.com/WnuY4Nr.png',
        website: 'https://www.yelp.com/biz/the-boba-shop-spring-4',
        blurb: 'Local cafe offering smoothies, tea, and coffee plus banh mi and dumplings.',
        description: ['Drinks', 'Mangonada', 'Board Games']
    },
    {
        name: 'Kung Fu Tea',
        category: 'coffee',
        badges: ['paid parking'],
        coordinates: [29.74273235292798, -95.37984373447486],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/xt7oaM6.png',
        website: 'https://www.kungfutea.com',
        blurb: 'Bubble tea specialist with a selection of other hot & cold drinks, including coffee & slushes.',
        description: ['Games', 'Tea', 'Boba']
    },
    {
        name: '7th Heaven Coffee & Eatery',
        category: 'coffee',
        subcategory: ['sandwiches'],
        badges: ['drive thru'],
        coordinates: [29.962428867202714, -95.2484748537011],
        neighborhood: 'Humble',
        img: 'https://i.imgur.com/8rVN86o.png',
        website: 'https://7thheavencoffee.square.site',
        blurb: 'Casual cafe with a drive-through window offering coffee drinks, tea, and quick eats.',
        description: ['Final Fantasy inspired', 'Tea', 'Sandwiches']
    },
    {
        name: 'Coral Sword',
        category: 'coffee',
        badges: ['NFC mobile payments', 'outdoor seating', 'alcohol available'],
        coordinates: [29.730795591901607, -95.32749000765905],
        neighborhood: 'Eastwood',
        img: 'https://i.imgur.com/RYBISZV.png',
        website: 'https://www.coralsword.com',
        blurb: 'Colorful board game cafe serving casual fare plus beer & coffee.',
        description: ['Play Board Games', 'Cofee & Tea', 'Hot Snacks']
    },
    {
        name: 'Brooklyn Cafe',
        category: 'coffee',
        subcategory: ['breakfast', 'bakery'],
        badges: ['NFC mobile payments', 'dog friendly'],
        coordinates: [30.1678675936134, -95.50326137083863],
        neighborhood: 'The Woodlands',
        img: 'https://i.imgur.com/13SmIaK.png',
        website: 'https://www.thebrooklyncafe.com',
        blurb: 'Bagels and other breakfast fare plus sandwiches in an easygoing cafe with a dog-friendly patio.',
        description: ['Bagels', 'Coffee', 'Dog-friendly']
    },
    {
        name: '85°C Bakery Cafe',
        category: 'coffee',
        subcategory: ['bakery', 'breakfast'],
        badges: ['NFC mobile payments'],
        coordinates: [29.78576631289384, -95.52225190971035],
        neighborhood: 'Blalock Market',
        img: 'https://i.imgur.com/K14RN5P.png',
        website: 'https://www.85cbakerycafe.com',
        blurb: 'Bakery/cafe chain with roots in Taiwan, offering coffee & tea plus international desserts & breads.',
        description: ['Potato Croquette', 'Cheese Dog', 'Bacon & Cheese']
    },
    {
        name: 'BlendIn Coffee Club',
        category: 'coffee',
        badges: ['NFC mobile payments'],
        coordinates: [29.760063881616148, -95.39922217883777],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/or8HviN.png',
        website: 'https://blendincoffeeclub.com',
        blurb: 'Casual coffee shop offering specialty coffee drinks and a selection of baked goods, including vegan options.',
        description: ['Laptop friendly', 'Diverse drink menu', 'Wholesale coffee']
    },
    {
        name: 'Tom N Toms Coffee',
        category: 'coffee',
        subcategory: ['breakfast', 'pizza', 'hotdogs'],
        badges: ['NFC mobile payments'],
        coordinates:[29.70446334086218, -95.54927030546189],
        neighborhood: 'Chinatown',
        img: 'https://i.imgur.com/6tEHFGb.png',
        website: 'https://www.tomntomsbellaire.com',
        blurb: 'Chain cafe offering a selection of coffees, teas, and small plates in a cozy space.',
        description: ['Smoothies', 'Pizza Toast', 'Egg Sandos']
    },
    {
        name: "Jeff's Bagel Run",
        category: 'coffee',
        subcategory: ['breakfast'],
        coordinates: [29.70534774550307, -95.43868953381072],
        neighborhood: 'West University Place',
        img: 'https://i.imgur.com/T6IvG3Q.png',
        website: 'https://jeffsbagelrun.com/locations/west-u/',
        blurb: "Jeff’s Bagel Run, founded by Jeff and Danielle Perera in Central Florida, brings authentic New York-style, hand-rolled, boiled bagels to the community—born from a home kitchen, fueled by local love, and now a thriving bakery with a heartwarming story.",
        description: ['Jalapeno Cheddar', 'Asiago Everything', 'Cacio E Pepe']
    },
    {
        name: 'The Coffee House',
        category: 'coffee',
        badges: ['NFC mobile payments', 'outdoor seating'],
        coordinates: [29.769282495387895, -95.40888740795157],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/BZ14U42.png',
        website: 'https://www.thecoffeehousehtx.com',
        blurb: 'Industrial-style redbrick establishment offering specialty coffees & pastries amid a relaxed vibe.',
        description: ['Coffee', 'Plenty of seating', 'Great for remote work']
    },
    {
        name: 'Doshi House',
        category: 'coffee',
        subcategory: ['sandwiches', 'breakfast', 'tacos', 'soup'],
        badges: ['NFC mobile payments', 'vegetarian options'],
        coordinates: [29.73259941186283, -95.3662694924411],
        neighborhood: 'South Central',
        img: 'https://i.imgur.com/BiO4D2b.png',
        website: 'https://www.doshihouse.com',
        blurb: 'Homey spot focusing on global vegetarian & vegan soups, sandwiches & mains, plus coffees & teas.',
        description: ['Pastries', 'Tea', 'Smoothies']
    },
    {
        name: 'Kolache Shoppe',
        category: 'coffee',
        subcategory: ['bakery', 'breakfast'],
        badges: ['NFC mobile payments', 'drive thru'],
        coordinates: [29.790311070967398, -95.39803149309529],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/pgcWQ6f.png',
        website: 'https://kolacheshoppe.com',
        blurb: 'Counter-serve pastry shop offering kolaches with both sweet & savory fillings plus cinnamon rolls.',
        description: ['Chai Latte', 'Ham & Swiss Kolache', 'Weekly Specials']
    },
    {
        name: 'RoadRunners',
        category: 'coffee',
        badges: ['NFC mobile payments', 'drive thru'],
        coordinates: [29.916246915748598, -95.62999454911026],
        neighborhood: 'Cypress',
        img: 'https://i.imgur.com/CAkz6W4.png',
        website: 'https://www.roadrunnersfast.com',
        blurb: "The World's Fastest Beverage Drive-Thru. Coffee in less than 60 seconds.",
        description: ['Milkshakes', 'Coffee', 'Energy Drinks']
    },
    // Markets
    {
        name: 'Houston Dairymaids',
        category: 'market',
        badges: ['NFC mobile payments'],
        coordinates: [29.80692355084747, -95.38224940513896],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/gGu9kbQ.png',
        website: 'https://www.houstondairymaids.com',
        blurb: 'Handmade cheeses from Texas & elsewhere, plus wine, beer, foodie-oriented gift items & tastings.',
        description: ['Cheese samples', ]
    },
    {
        name: 'H Mart',
        category: 'market',
        subcategory: ['hall'],
        badges: ['alcohol available'],
        coordinates: [29.792680234069884, -95.77433038249025],
        neighborhood: 'Katy',
        img: 'https://i.imgur.com/HVUrkrB.png',
        website: 'https://www.hmart.com/',
        blurb: 'Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.',
        description: ['Noodles', 'Produce', 'Food Court']
    },
    {
        name: 'Mi Tienda',
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.869779060715402, -95.33290961508173],
        neighborhood: 'Little York',
        img: 'https://i.imgur.com/lqJKoeX.png',
        website: 'https://mitiendatx.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores&utm_content=mi_tienda_648',
        blurb: 'Sizable Latin grocery store with a tortilleria & a bakery, plus ready-made food court eats.',
        description: ['Mexican Market', 'Food Court', 'Fresh Produce']
    },
    {
        name: "Trader Joe's",
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.73920558665379, -95.41112752066111],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/GHrfdPc.png',
        website: 'https://locations.traderjoes.com/tx/houston/426/?utm_source=gmb&utm_medium=organic&utm_campaign=local',
        blurb: 'Grocery chain with a variety of signature items, plus produce, dairy & more.',
        description: ['Ready to eat meals', 'wine & beer', 'seasonal foods']
    },
    {
        name: 'Phoenicia Specialty Foods',
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.75441879503811, -95.36160806283416],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/cUVgFdW.png',
        website: 'https://phoeniciafoods.com/locations/downtown-market/',
        blurb: 'Mediterranean market with deli & prepared foods, plus cheeses, baked goods, meats, wine & beer.',
        description: ['mediterranean', 'ready to eat snacks', 'specialty foods']
    },
    {
        name: 'Phoenicia Specialty Foods',
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.734632883016253, -95.59485050486693],
        neighborhood: 'Westside',
        img: 'https://i.imgur.com/KgoJrYo.png',
        website: 'https://phoeniciafoods.com/locations/westheimer-market/',
        blurb: 'Mediterranean market with deli & prepared foods, plus cheeses, baked goods, meats, wine & beer.',
        description: ['Mediterranean', 'Ready to eat snacks', 'Specialty foods']
    },
    {
        name: '99 Ranch Market',
        category: 'market',
        subcategory: ['hall'],
        badges: ['alcohol available'],
        coordinates: [29.785449825593115, -95.5229681661174],
        neighborhood: 'Blalock Market',        
        img: 'https://i.imgur.com/lscVoE1.png',
        website: 'https://www.99ranch.com/stores/search',
        blurb: 'Asian supermarket chain carrying imported specialty foods plus meat, seafood, produce & baked goods.',
        description: ['Asian foods', 'Restaurants attached', 'Pricier than H Mart']
    },
    {
        name: '99 Ranch Market',
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.737573908010656, -95.59568067398935],
        neighborhood: 'Westside',      
        img: 'https://i.imgur.com/QyyVC3v.png',
        website: 'https://www.99ranch.com/stores/search',
        blurb: 'Asian supermarket chain carrying imported specialty foods plus meat, seafood, produce & baked goods.',
        description: ['Asian foods', 'Restaurants attached', 'Pricier than H Mart']
    },
    {
        name: '99 Ranch Market',
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.775705653355033, -95.7501533006404],
        neighborhood: 'Katy',      
        img: 'https://i.imgur.com/TQphagr.png',
        website: 'https://www.99ranch.com/stores/search',
        blurb: 'Asian supermarket chain carrying imported specialty foods plus meat, seafood, produce & baked goods.',
        description: ['Asian foods', 'Restaurants attached', 'Pricier than H Mart']
    },
    {
        name: 'Whole Foods Market',
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.81378493265026, -95.39815226977178],
        neighborhood: 'Independence Heights',  
        img: 'https://i.imgur.com/o7vIOi4.png',
        website: 'https://www.wholefoodsmarket.com/stores/independenceheights?utm_sourc',
        blurb: 'Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).',
        description: ['Fresh pizza', 'Tin fish', 'Wine']
    },
    {
        name: 'H-E-B',
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.807331827706797, -95.40907973637934],
        neighborhood: 'Heights',  
        img: 'https://i.imgur.com/w4H8HWL.png',
        website: 'https://www.heb.com/heb-store/US/tx/houston/the-heights-h-e-b-737?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores',
        blurb: 'Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.',
        description: ['Fresh Sushi', 'Groceries', 'Pharmacy']
    },
    {
        name: 'H-E-B',
        category: 'market',
        subcategory: ['crawfish'],
        badges: ['alcohol available'],
        coordinates: [29.923112090034746, -95.19692257308988],
        neighborhood: 'Summerwood',
        img: 'https://i.imgur.com/QUvViYV.png',
        website: 'https://www.heb.com/heb-store/US/tx/houston/summerwood-market-h-e-b-614?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores',
        blurb: 'Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.',
        description: ['Fresh Sushi', 'Groceries', 'Seasonal Seafood Boils']        
    },
    {
        name: 'B & W Meat Company',
        category: 'market',
        coordinates: [29.835171688340367, -95.41169405321867],
        neighborhood: 'Independence Heights',  
        img: 'https://i.imgur.com/Dk66E5Q.png',
        website: 'https://bwmeatcompany.com',
        blurb: 'Butcher shop offering high-quality meats, housemade sausage, custom cuts, deer processing & more.',
        description: ['Butcher', 'Oxtail', 'Brisket']
    },
    {
        name: 'H Mart',
        category: 'market',
        subcategory: ['hall'],
        badges: ['alcohol available'],
        coordinates: [29.792552001430632, -95.5209030224523],
        neighborhood: 'Blalock Market',  
        img: 'https://i.imgur.com/9cruNYm.png',
        website: 'https://www.hmart.com/',
        blurb: 'Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.',
        description: ['Noodles', 'Produce', 'Food Court']
    },
    {
        name: 'H Mart',
        category: 'market',
        subcategory: ['hall'],
        badges: ['alcohol available'],
        coordinates: [29.706641204872156, -95.55391477248872],
        neighborhood: 'Chinatown',  
        img: 'https://i.imgur.com/K0nt0I0.png',
        website: 'https://www.hmart.com/',
        blurb: 'Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.',
        description: ['Noodles', 'Produce', 'Food Court']
    },
    {
        name: 'Sprouts',
        category: 'market',
        subcategory: ['sandwiches'],
        badges: ['alcohol available'],
        coordinates: [29.774566750083107, -95.40017316062348],
        neighborhood: 'Washington',  
        img: 'https://i.imgur.com/kN1pdBy.png',
        website: 'https://www.sprouts.com/store/tx/houston/the-heights/',
        blurb: 'Specialty chain offering a range of natural & organic grocery items, including own-brand goods.',
        description: ['Fresh sandwiches', 'Candy', 'Organic groceries']
    },
    {
        name: 'Central Market',
        category: 'market',
        badges: ['alcohol available'],
        coordinates: [29.740862933310016, -95.44399540235871],
        neighborhood: 'River Oaks',  
        img: 'https://i.imgur.com/1RL7t9V.png',
        website: 'https://www.centralmarket.com/locations/houston?utm_source=google&utm_medium=organic&utm_campaign=cm_stores',
        blurb: 'Gourmet veggies, meats & wine, plus an in-house cafe, food events & live music in a vast space.',
        description: ['Fancy H-E-B', 'Cooking classes', 'Premium groceries']
    },
    {
        name: 'M-K-T',
        category: 'market',
        subcategory: ['hall'],
        badges: ['NFC mobile payments', 'alcohol available', 'photogenic'],
        coordinates: [29.782477728835328, -95.40796615849794],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/iqolIM0.png',
        website: 'https://www.themkt.com',
        blurb: 'Trail-oriented complex with a mix of shops and restaurants, some offering outdoor seating.',
        description: ['Blue Sushi', 'La La Land Coffee', 'Walking Trails']
    },
    {
        name: 'Sunny Flea Market',
        category: 'market',
        subcategory: ['hall'],
        badges: ['paid parking'],
        coordinates: [29.886206377424145, -95.3956386957484],
        neighborhood: 'Airline',
        img: 'https://i.imgur.com/3cG2BVh.png',
        website: 'https://www.instagram.com/sunnyfleamarket/',
        blurb: 'Weekend flea market offering a variety of goods and street food.',
        description: ['$2 Parking', 'Street Food', 'Weekends Only']
    },
    {
        name: 'Ironworks',
        category: 'market',
        coordinates: [29.74476521973961, -95.33926501078673],
        neighborhood: 'Eastwood',
        img: 'https://i.imgur.com/LBClbah.png',
        website: 'https://ironworks.glide.page/dl/245b4e',
        blurb: "This is where businesses and neighbors grow together. Whether you're grabbing a cup of coffee, getting a haircut, attending a class, or meeting your next business partner, here, you can do it all. ",
        description: ['Food & Drink', 'Retail', 'Office & Studio']
    },
    {
        name: 'Houston Farmers Market',
        category: 'market',
        coordinates: [29.8102928618855, -95.38041838117448],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/RlKxF01.png',
        website: 'https://thehoustonfarmersmarket.com',
        blurb: "Farmers' market featuring a large selection of produce, including medicinal herbs, and spices.",
        description: ['Fresh produce', 'Plant nursery', 'Food & Drink']
    },
    {
        name: 'Whole Foods',
        category: 'market',
        coordinates: [29.739403104663417, -95.41815918307897],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/kqD33UD.png',
        website: 'https://www.wholefoodsmarket.com/stores/kirby?utm_source=google&utm_medium=organic&utm_campaign=listings',
        blurb: 'Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).',
        description: ['Fresh pizza', 'Tin fish', 'Wine']
    },
    // Movie Theaters
    {
        name: 'AMC Willowbrook 24',
        category: 'movies',
        coordinates: [29.95353569926177, -95.54006845262985],
        neighborhood: 'Willowbrook',  
        img: 'https://i.imgur.com/7j18fGs.png',
        website: 'https://www.amctheatres.com/movie-theatres/houston/amc-willowbrook-24',
        blurb: 'Casual movie theater with IMAX, Dolby Cinema, and Prime at AMC, plus rocking seats and recliners.',
        description: ['Premium seats', 'Digital IMAX', 'Dolby Digital']
    },
    {
        name: 'AMC Deerbrook 24',
        category: 'movies',
        coordinates: [30.010016013578735, -95.27108698884724],
        neighborhood: 'Deerbrook',  
        img: 'https://i.imgur.com/hkIrPr8.png',
        website: 'https://www.amctheatres.com/movie-theatres/houston/amc-deerbrook-24',
        burb: '',
        description: ['Premium seats', 'Digital IMAX', 'Dolby Digital']
    },
    {
        name: 'AMC Houston 8',
        category: 'movies',
        coordinates: [29.761902952575078, -95.36625280604103],
        neighborhood: 'Downtown',  
        img: 'https://i.imgur.com/Ft6rlvE.png',
        website: 'https://www.amctheatres.com/movie-theatres/houston/amc-houston-8',
        burb: '',
        description: ['Premium seats', 'Digital IMAX', 'Dolby Digital']
    },
    {
        name: "Regal Edwards Houston Marq'E",
        category: 'movies',
        coordinates: [29.785954755242336, -95.4635497896941],
        neighborhood: 'Northwest Houston',
        img: 'https://i.imgur.com/xHaBTom.png',
        website: 'https://regmovies.com',
        blurb: 'Movie theater chain known for presenting 3D films on a giant screen, including blockbusters.',
        description: ['IMAX', 'Screen X', '4DX']
    },
    {
       name: 'Regal Lone Star',
       category: 'movies',
       coordinates: [30.041429887488842, -95.60524921864557],
       neighborhood: 'Spring',
       img: 'https://i.imgur.com/rRvHN2t.png',
       website: 'http://regmovies.com',
       blurb: 'Theater complex with multiple screens featuring new release films, plush seating & concession stand.',
       description: ['Movies', 'Popcorn', 'Soda'] 
    },
    {
        name: 'Alamo Drafthouse Cinema LaCenterra',
        category: 'movies',
        coordinates: [29.740641105182316, -95.77402693978205],
        neighborhood: 'Cinco Ranch',  
        img: 'https://i.imgur.com/WL4kIO0.png',
        website: 'https://drafthouse.com',
        blurb: 'Stylish theater chain for new & classic films features cocktails & creative bites served seat-side.',
        description: ['Creative Menu', 'Seat-side Service', 'Eclectic Film Selection']
    },
    {
        name: 'Star Cinema Grill - HWY 249',
        category: 'movies',
        coordinates: [29.994647477255967, -95.57278076841475],
        neighborhood: 'Tomball',
        img: 'https://i.imgur.com/MTkFi0H.png',
        website: 'https://starcinemagrill.net',
        blurb: 'Stylish theater chain for new & classic films features cocktails & creative bites served seat-side.',
        description: ['Full Bar', 'Full Restaurant', 'Table Service']
    },
    {
        name: 'Regal Edwards Greenway Grand Palace',
        category: 'movies',
        coordinates: [29.731383893300645, -95.44073989122626],
        neighborhood: 'Greenway',  
        img: 'https://i.imgur.com/TYifVuY.png',
        website: 'https://regmovies.com',
        blurb: 'Theater complex with multiple screens featuring new release films, plush seating & concession stand.',
        description: ['Movies', 'Popcorn', 'Soda'] 
    },
    {
        name: 'The River Oaks Theatre',
        category: 'movies',
        coordinates: [29.75267309523697, -95.40907147983143],
        neighborhood: 'River Oaks',  
        img: 'https://i.imgur.com/tbkApma.png',
        website: 'https://theriveroakstheatre.com',
        blurb: 'Movie theater screening new releases as well as independent, foreign & avant-garde flicks.',
        description: ['Historic', 'Local', 'Retro']
    },
    {
        name: 'Rooftop Cinema Club Uptown',
        category: 'movies',
        coordinates: [29.749438473419687, -95.46172275862284],
        neighborhood: 'Uptown',  
        img: 'https://i.imgur.com/w2uQJt0.png',
        website: 'https://rooftopcinemaclub.com/houston/venue/uptown/',
        blurb: 'Open-air cinema offering concessions, headphones, and city views, plus special events.',
        description: ['Rooftop', 'Outdoor seating', 'Monthly Schedules']
    },
    {
        name: 'Cinemark Katy and XD',
        category: 'movies',
        coordinates: [29.786772479707707, -95.77473708220901],
        neighborhood: 'Katy',  
        img: 'https://i.imgur.com/5BLFALw.png',
        blurb: 'Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.',
        description: ['Near H-Mart', 'Cinemark XD', 'Snack Bar']
    },
    // Music Venues
    {
        name: 'House of Blues - Houston',
        category: 'music',
        badges: ['paid parking', 'alcohol available', 'live music' ],
        coordinates: [29.75383522265906, -95.36392444303341],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/k5dSSlt.png',
        website: 'https://www.livenation.com/venue/KovZpZAE6k1A/house-of-blues-houston-events?awtrc=true&c=SEM_LNVenuesAutomation_ggl_18519938348_142072537436_house%20of%20blues&GCID=0&gad_source=1&gbraid=0AAAAAC1KtUphGOVv8Rofb-wxM6BpSibhT&gclid=Cj0KCQjwtpLABhC7ARIsALBOCVoSlXtVubE-SSFspbLCjloWham5bis77jY47pOXUM-yH7Rv6b9LRIEaAhEiEALw_wcB&gclsrc=aw.ds',
        blurb: "Rock- & blues-themed restaurant & bar serving Southern-inspired dishes, plus live music.",
        description: ['House of blues', 'Bronze peacock', 'Foundation room']
    },
    {
        name: 'Warehouse Live',
        category: 'music',
        badges: ['paid parking', 'alcohol available', 'live music'],
        coordinates: [29.746012478013213, -95.3750447679838],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/VxrN62G.png',
        website: 'https://www.google.com/search?q=warehouse+live&sca_esv=1568361547b35126&sxsrf=AHTn8zowcBcGXM32ZoZru3el8iKuUm81Lg%3A1745251128310&ei=OGsGaKrFEvLep84PicCx4QQ&ved=0ahUKEwiqwa-Mv-mMAxVy78kDHQlgLEwQ4dUDCBA&uact=5&oq=warehouse+live&gs_lp=Egxnd3Mtd2l6LXNlcnAaAhgCIg53YXJlaG91c2UgbGl2ZTITEC4YgAQYxwEYJxiKBRiOBRivATIEECMYJzIKEAAYgAQYQxiKBTIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgARI4QxQAFjsC3AAeAGQAQCYAYIBoAHgCqoBAzguNrgBA8gBAPgBAZgCDqACowvCAgoQIxiABBgnGIoFwgITEC4YgAQYQxjHARiKBRiOBRivAcICEBAuGIAEGEMYxwEYigUYrwHCAhYQLhiABBixAxjRAxhDGIMBGMcBGIoFwgIQEAAYgAQYsQMYQxiDARiKBcICExAuGIAEGLEDGNEDGEMYxwEYigXCAg0QABiABBhDGIoFGIsDwgIZEC4YgAQYQxiYAxioAxiKBRiaAxiLAxibA8ICEBAuGIAEGLEDGEMYgwEYigXCAg0QABiABBixAxhDGIoFwgIOEC4YgAQYxwEYjgUYrwHCAgoQABiABBgUGIcCmAMAkgcDNi44oAeV6AGyBwM2Lji4B6ML&sclient=gws-wiz-serp',
        blurb: 'Various music styles are showcased at this basic general-admission concert venue with a small bar.',
        description: ['Medium size concerts', 'Walkable area', 'Drinks and good nearby']
    },
    {
        name: 'White Oak Music Hall',
        category: 'music',
        badges: ['paid parking', 'alcohol available', 'live music'],
        coordinates: [29.786245855756498, -95.36701642980238],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/lh9c1Eu.png',
        website: 'https://whiteoakmusichall.com/',
        blurb: 'Performances by popular musical acts staged in an amphitheater with a lawn, plus 2 indoor spaces.',
        description: ['Upstairs room', 'Downstairs room', 'Lawn shows']
    },
    {
        name: '713 Music Hall',
        category: 'music',
        badges: ['paid parking', 'alcohol available', 'live music'],
        coordinates: [29.765904133313427, -95.36386788724305],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/t93sdjO.png',
        website: 'https://www.713musichall.com/?utm_source=GMBlisting&utm_medium=organic',
        blurb: 'Venue in a former post office with a restaurant and bar, hosting a variety of artists.',
        description: ['Paid parking', 'Attached to POST Food Hall', 'Medium to large concerts']
    },
    {
        name: 'Heights Theater',
        category: 'music',
        badges: ['alcohol available', 'live music'],
        coordinates: [29.80306916916203, -95.40285985023765],
        neighborhood: 'Heights',
        img: 'https://i.imgur.com/BNG0lPy.png',
        website: 'https://theheightstheater.com',
        blurb: 'Restored early-1900s movie theater available for private events, with marquee & film projector.',
        description: ['Smaller shows', 'Walkable neighborhood', 'Old movie theater']
    },
    {
        name: 'The Bronze Peacock',
        category: 'music',
        badges: ['alcohol available', 'live music'],
        coordinates: [29.75390437423625, -95.36408936405562],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/CnsV7fk.png',
        website: 'https://locations.houseofblues.com/restaurant-and-bar/tx/houston/1204-caroline-st.',
        blurb: 'Smaller venue attached to House of Blues - Houston',
        description: ['House of blues', 'Foundation room', 'Cheap tickets']
    },
    {
        name: 'The Foundation Room',
        category: 'music',
        badges: ['alcohol available', 'live music', 'DJ'],
        coordinates: [29.753973571962955, -95.36402390495192],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/0ghz4Sg.png',
        website: 'https://locations.houseofblues.com/foundation-room/tx/houston/1204-caroline-st.',
        blurb: 'Upscale lounge featuring a New American restaurant, plus craft cocktails, and live music.',
        description: ['VIP room', 'House of blues', 'Bronze peacock']
    },
    {
        name: "Rockefeller's",
        category: 'music',
        badges: ['live music'],
        coordinates: [29.769681526351384, -95.39680068906254],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/i5DyCEI.png',
        website: 'http://www.rockefellershouston.com',
        blurb: 'Intimate venue with a bar hosting live music performances, including blues and jazz, and poetry events.',
        description: ['Intimate', 'Less frequent concerts', 'Private rentals']
    },
    {
        name: 'Eldorado Ballroom',
        category: 'music',
        badges: ['live music'],
        coordinates: [29.734460962203446, -95.36542150051352],
        neighborhood: 'South Central',
        img: 'https://i.imgur.com/H3NJeKJ.png',
        website: 'https://www.theeldoradoballroom.com',
        blurb: 'Eldorado Ballroom is a former nightclub in the Third Ward, Houston, on the other side of the road from Emancipation Park.',
        description: ['Intimate', 'Private events', 'Historic']
    },
    {
        name: 'Bayou Music Center',
        category: 'music',
        badges: ['paid parking', 'alcohol available', 'live music'],
        coordinates: [29.762360386097406, -95.36749274478409],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/vo0kW16.png',
        website: 'https://www.bayoumusiccenter.com/?utm_source=GMBlisting&utm_medium=organic',
        blurb: 'Cozy performing arts center featuring nationally known musicians & comedians since 1997.',
        description: ['Medium size concerts', 'Downtown area', 'Walkable area']
    },
    {
        name: 'Cactus Music',
        category: 'music',
        badges: ['live music'],
        coordinates: [29.733567939771763, -95.41127535965643],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/Q6Ft77d.png',
        website: 'https://www.cactusmusictx.com',
        blurb: 'Huge emporium for rare vinyl albums & used DVDs, records & CDs hosts local music performances too.',
        description: ['Record store', 'Small concerts', 'Prints & DVDs']
    },
    {
        name: 'The Secret Group',
        category: 'music',
        badges: ['paid parking', 'NFC mobile payments', 'alcohol available', 'live music'],
        coordinates: [29.7490562478942, -95.35702886299184],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/ErZM6Bk.png',
        website: 'https://www.thesecretgrouphtx.com',
        blurb: 'Dark, quirky nightspot offering a bar area, rooftop patio & back showroom for music & comedy nights.',
        description: ['Rooftop Patio', 'Comedy', 'Music']
    },
    // Parks
    {
        name: 'Hermann Park',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.717301075222434, -95.3909421495944],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/i7Msrr8.png',
        website: 'https://hermannpark.org',
        blurb: 'Expansive park featuring a golf course, Japanese garden, a natrual science museum & a kiddie train.',
        description: ['Houston zoo', 'Proximity to museums', 'Japanese garden']
    },
    {
        name: 'McGovern Centennial Gardens',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.720893009262795, -95.38748097934554],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/oSlIHZ4.jpeg',
        website: 'https://hermannpark.org/visit/mcgovern-centennial-gardens/',
        blurb: 'An 8-acre site featuring themed gardens, a sculpture promenade & a 30-foot mount with city views.',
        description: ['Rose Garden', 'Friendhsip Pavillion', 'Sculpture Walking Trail']
    },
    {
        name: 'Japanese Garden',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.719023089618833, -95.3922959042466],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/BWVEc9t.png',
        website: 'https://hermannpark.org/visit/points-of-interest/',
        blurb: 'Tranquil Japanese garden in Hermann Park featuring plants, ponds & rocks, plus a teahouse.',
        description: ['Walking trails', 'Ducks', 'Japanese Aesthetic']
    },
    {
        name: 'Gerald D. Hines Waterfall Park',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.736395850451597, -95.46129776187128],
        neighborhood: 'Westside',
        img: 'https://i.imgur.com/AJ1hgeo.png',
        website: 'https://uptown-houston.com/experience/parks/waterwall-park/',
        blurb: 'Park whose centerpiece is a 64-ft.-tall fountain circulating 11,000 gallons per minute.',
        description: ['Massive Waterfall', 'Walkable Area', 'Tree Canopies']        
    },
    {
        name: 'West Lake Park',
        category: 'park',
        coordinates: [29.921505793676292, -95.20916263040671],
        neighborhood: 'Summerwood',
        img: 'https://i.imgur.com/vR51AJw.png',
        website: 'www.mapquest.com/us/texas/west-lake-park-420089509',
        blurb: 'Unpaved, tree-lined trail with a pond for wildlife viewing and a solid walking bridge.',
        description: ['Great for walking', 'Beatiful lake', 'Bridges over lake']
    },
    {
        name: 'Jesse H. Jones Park & Nature Center',
        category: 'park',
        coordinates: [30.026748418753336, -95.29677063305253],
        neighborhood: 'Humble',
        img: 'https://i.imgur.com/V5dMRMK.png',
        website: 'https://www.visithoustontexas.com/listings/jesse-h-jones-park-%26-nature-center/20236/',
        blurb: 'This large tract features play & fishing areas, an educational facility & a network of trails.',
        description: ['Walking Trails', 'Turtles', 'Birding']
    },
    {
        name: 'Eleanor Tinsley Park',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.761374885269195, -95.37885567530404],
        neighborhood: 'Fourth Ward',
        img: 'https://i.imgur.com/eiLgeC7.png',
        website: 'https://downtownhouston.org/go/eleanor-tinsley-park',
        blurb: 'Park popular for its running trails, lush green hills & playing host to multiple annual festivals.',
        description: ['Connects to downtown', 'Beach volleyball', 'View of skyline']
    },
    {
        name: 'Buffalo Bayou Park Cistern',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.762086622873017, -95.37651349958786],
        neighborhood: 'Fourth Ward',
        img: 'https://i.imgur.com/KYh8RCH.png',
        website: 'https://www.buffalobayou.org/location/the-cistern/',
        blurb: 'This decommissioned underground reservoir was built in 1926 & now features art installations.',
        description: ['Light shows', 'Events', 'Walkable Area']
    },
    {
        name: 'Buffalo Bayou Park',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.761675749675707, -95.38298771065615],
        neighborhood: 'Fourth Ward',
        img: 'https://i.imgur.com/grW6XMU.png',
        website: 'https://buffalobayou.org/location/buffalo-bayou-park/',
        blurb: 'Winding 160-acre green space featuring views of the Houston skyline plus a fountain & skate park.',
        description: ['Jane Gregory Garden', 'Tolerance (Plensa) Statues', 'Spindle Sculpture']
    },
    {
        name: 'Houston Arboretum & Nature Center',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.764528595602318, -95.45235240872859],
        neighborhood: 'Memorial Park',
        img: 'https://i.imgur.com/oc1HULk.jpeg',
        website: 'https://houstonarboretum.org',
        blurb: '155-acre urban green space offering nature trails, exhibits, workshops & events in various habitats.',
        description: ['Gardens', 'Walking Trails', 'Ponds']
    },
    {
        name: 'Memorial Park Mountain Biking Trails',
        category: 'park',
        coordinates: [29.76200492007245, -95.44252415394965],
        neighborhood: 'Memorial Park',
        img: 'https://i.imgur.com/rvYHgWs.png',
        website: 'https://www.trailforks.com/region/memorial-park/',
        blurb: 'Mountain Bikers are especially fond of trails located in the southwest section of Memorial Park. These trails are color coded with maps at the trailhead signs. The mountain bike trails are affected by weather and are closed if conditions warrant to preserve the trails.',
        description: ['Garden', 'Walking Trails', 'Art installations']
    },
    {
        name: 'Clay Family Eastern Glades',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.76671697995398, -95.43031888718707],
        neighborhood: 'Memorial Park',
        img: 'https://i.imgur.com/QfzjPHb.png',
        website: 'https://www.memorialparkconservancy.org/discover/master-plan/eastern-glades/',
        blurb: 'Park offering public restrooms, picnic tables, trails, and a lake with ducks.',
        description: ['Garden', 'Walking Trails', 'Art installations']
    },
    {
        name: 'Memorial Park',
        category: 'park',
        coordinates: [29.767614728267546, -95.43987406688974],
        neighborhood: 'Memorial Park',
        img: 'https://i.imgur.com/ShywnSR.jpeg',
        website: 'https://www.memorialparkconservancy.org',
        blurb: 'Expansive city park with lush natural features, popular running trail, golf course & lots of shade.',
        description: ['Biking Trails', 'Sports Complex', 'Nature Centers']
    },
    {
        name: 'Keith-Wiess Park',
        category: 'park',
        coordinates: [29.89209916399693, -95.34494706745201],
        neighborhood: 'East Aldine',
        img: 'https://i.imgur.com/JkuESMT.png',
        website: 'https://aldinedistrict.org/gallery-page/parks-and-recreation/',
        blurb: 'This expansive park features ball fields & tennis courts, plus trails & picnic areas.',
        description: ['walking trails', 'natural ponds', '1-2 hour walk']
    },
    {
        name: 'George Bush Park Boardwalk',
        category: 'park',
        coordinates: [29.737655260492083, -95.70020706442541],
        neighborhood: 'Katy',
        img: 'https://i.imgur.com/DeGD5ik.png',
        website: 'https://cp4.harriscountytx.gov/Explore/Parks/park/george-bush-park',
        blurb: 'George Bush Park is a county park in Houston, Texas, United States, located on the far west side of the city. Situated entirely within Barker Reservoir, a large flood control structure, the park covers 7,800 acres, most of which is undeveloped forest used for the storage of floodwater. ',
        description: ['Long walk to boardwalk', 'Large alligators', 'Walking trais']
    },
    {
        name: 'Smither Park',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.71685018952467, -95.32464507168103],
        neighborhood: 'Gulfgate',
        img: 'https://i.imgur.com/MLbGtZP.png',
        website: 'https://orangeshow.com',
        blurb: 'Urban green space with a quirky collection of large mosaic sculptures created by local artists.',
        description: ['Artistic', 'Local culture', 'Quirky']
    },
    {
        name: 'Clear Lake Park',
        category: 'park',
        coordinates: [29.564997477711, -95.0675657604324],
        neighborhood: 'Kemah',
        img: 'https://i.imgur.com/tBfhTlE.png',
        website: 'https://www.visithoustontexas.com/listings/clear-lake-park-bay-area-museum/20767/',
        blurb: 'Park with archaeological features on 59 acres with fishing pier, boat launch, playground & trails.',
        description: ['Close to Kemah', 'Relaxing', 'Great lake view']
    },
    {
        name: 'Sheldon Lake State Park',
        category: 'park',
        coordinates: [29.860423185296234, -95.16076925862397],
        neighborhood: 'Summerwood',
        img: 'https://i.imgur.com/cSUVNnE.jpeg',
        website: 'https://tpwd.texas.gov',
        blurb: 'State park with wetlands, lake & ponds for fishing & wildlife watching, plus educational exhibits.',
        description: ['Observation tower', 'Wetlands walking trails', 'Lush ponds']
    },
    {
        name: 'Sam Houston Park',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.760128161149296, -95.37212300100511],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/5A1nr6N.jpeg',
        website: 'https://www.houstontx.gov/abouthouston/samhoustonpark.html',
        blurb: 'Historically focused park featuring guided tours of old structures dating back to the 1800s.',
        description: ['Downtown', 'Frequent events', 'Access to Buffalo Bayou']
    },
    {
        name: 'Market Square Park',
        category: 'park',
        badges: ['photogenic', 'dog friendly'],
        coordinates: [29.76261811690755, -95.36235930384555],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/xc886p9.png',
        website: 'https://downtownhouston.org/go/market-square-park',
        blurb: 'Historic public space with outdoor movies, walkways, a dog run & an open-air Greek restaurant.',
        description: ['Movies in the park', 'Proximity to bars', 'Proximity to restaurants']
    },
    {
        name: 'Discovery Green',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.753051375319636, -95.35957755310606],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/cQkkSbH.jpeg',
        website: 'https://www.discoverygreen.com/',
        blurb: 'Park with live music, public art, restaurants, playground, pong for kayaking & exercise classes.',
        description: ['Events', 'Walkable Area', 'Family-friendly']
    },
    {
        name: 'Guadalupe Plaza Park',
        category: 'park',
        coordinates: [29.75992389270082, -95.34570820433815],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/giQvIqe.png',
        website: 'https://www.eastenddistrict.com/capital-projects/guadalupe-plaza-park-nears-completion/',
        blurb: 'Public park known for hosting events, including wine festivals.',
        description: ['Events', 'East of Downtown', 'Walkable']
    },
    {
        name: 'Woodland Park Bird Sanctuary',
        category: 'park',
        coordinates: [29.781623738438856, -95.37042159415712],
        neighborhood: 'Northside',
        img: 'https://i.imgur.com/imwORpW.png',
        website: 'https://www.friendsofwoodlandpark.org/birds',
        blurb: 'Woodland Park, located a few miles from downtown in Woodland Heights, is an excellent park for urban birding.',
        description:['Birding', 'Walkable', 'Outdoor seating']
    },
    {
        name: 'Levy Park',
        category: 'park',
        badges: ['dog friendly'],
        coordinates: [29.732625704956543, -95.42328805641604],
        neighborhood: 'Greenway',
        img: 'https://i.imgur.com/8WwIAuu.png',
        website: 'https://www.levyparkhouston.org',
        blurb: 'This classic green space features a asoftball field & playground, plus a community garden & dog park.',
        description: ['food trucks', 'short walking trails', 'artistic']
    },
    {
        name: 'Bagby Park',
        category: 'park',
        badges: ['photogenic'],
        coordinates: [29.75183245570911, -95.37602483396185],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/GWn9kgv.png',
        website: 'https://midtownhouston.com/explore/parks/bagby-park/',
        blurb: 'Combat urban green space featuring a historic fountain, plus a trail, chess tables & public art.',
        description: ['Small park', 'La Calle Tacos', 'Large Fountain']
    },
    {
        name: 'Midtown Park',
        category: 'park',
        badges: ['dog friendly'],
        coordinates: [29.743629216217624, -95.37615072468216],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/tOTkk3u.jpeg',
        website: 'https://midtownhouston.com/project/midtown-park/',
        blurb: 'Urban space & events site with a dog park, a playground, sports courts & a wetland trail.',
        description: ['Ponds', 'Paved walking trails', 'Artistic']
    },
    {
        name: 'Emancipation Park',
        category: 'park',
        coordinates: [29.73568063718464, -95.36524382995843],
        neighborhood: 'South Central',
        img: 'https://i.imgur.com/RihX93k.png',
        website: 'https://epconservancy.org',
        blurb: 'Historic park dedicated to the end of slavery offers a pool, athletic fields & a large playground.',
        description: ['Community center', 'Pool', 'Memorials']
    },
    {
        name: 'Menil Park',
        category: 'park',
        coordinates: [29.73741753692353, -95.39706742222512],
        neighborhood: 'Montrose',
        img: 'https://i.imgur.com/Raxgswn.png',
        website: 'https://www.menil.org/visit/campus/menil-park',
        blurb: '30-acre urban gathering spot offering open lawns, trails & sculptures surrounded by shady oak trees.',
        description: ['Walkable Area', 'Drawing & Photography Centers', 'Large Trees']
    },
    {
        name: 'Sheldon Resevoir Public Access',
        category: 'park',
        coordinates: [29.882707076937123, -95.1859448947124],
        neighborhood: 'Summerwood',
        img: 'https://i.imgur.com/FV1lcid.png',
        website: 'https://tpwd.texas.gov/state-parks/sheldon-lake',
        blurb: 'Small access point by Sheldon Resevoir mostly used for fishing and passing time.',
        description: ['Quiet', 'Fishing', 'Roadside picnic']
    },
    // Attractions
    {
        name: 'Shell Stadium',
        category: 'attraction',
        subcategory: ['soccer'],
        badges: ['paid parking', 'alcohol available', 'photogenic'],
        coordinates: [29.75223407697903, -95.35244790076325],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/PtL0PQs.png',
        website: 'https://www.houstondynamofc.com/shell-energy-stadium/',
        blurb: "Shell Energy Stadium is an American multi-purpose stadium located in Houston, Texas, that is home to Houston Dynamo FC, a Major League Soccer club and the Houston Dash of the National Women's Soccer League and was the first soccer specific stadium built in a major metropolitan downtown city.",
        description: ['Home of the Dynamo', 'Home of the Dash', 'Diverse Food Options']
    },
    {
        name: 'Daikin Park',
        category: 'attraction',
        subcategory: ['baseball'],
        badges: ['paid parking', 'alcohol available'],
        coordinates: [29.756949099940385, -95.35528934297224],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/pI1A6fu.png',
        website: 'https://www.mlb.com/astros/ballpark',
        blurb: "Astros' home ballpark with retractable roof, plenty of concessions options & a train station theme.",
        description: ['Home of the Astros', 'themed nights', 'hotdogs']
    },
    {
        name: 'Kemah Boardwalk',
        category: 'attraction',
        badges: ['photogenic'],
        subcategory: ['kemah'],
        badges: ['paid parking', 'alcohol available'],
        coordinates: [29.547601137961802, -95.01973613835622],
        neighborhood: 'Kemah',
        img: 'https://i.imgur.com/j9s4KLr.jpeg',
        website: 'https://www.kemahboardwalk.com',
        blurb: 'Kemah Boardwalk is a sprawling entertainment complex, with waterfront dining and theme-park rides, plus a stingray touch pool and a rainforest exhibit with snakes and turtles.',
        description: ['Amusement Park', 'Bayside', 'Restaurants']
    },
    {
        name: 'Andretti Indoor Karting & Games',
        category: 'attraction',
        subcategory: ['gokart'],
        badges: ['open late', 'alcohol available'],
        coordinates: [29.78932631988743, -95.76945188644805],
        neighborhood: 'Katy',
        img: 'https://i.imgur.com/aiBqZz2.png',
        website: 'https://andrettikarting.com/katy',
        blurb: 'Indoor sports hub with a karting track, video arcades & VR games, plus laser tag & food trucks.',
        description: ['Fast Go Karts', 'VR Gaming', 'Laser Tag']
    },
    {
        name: 'Meow Wolf',
        category: 'attraction',
        subcategory: ['meow'],
        badges: ['alcohol available', 'photogenic'],
        coordinates: [29.772103990703904, -95.34773256280762],
        neighborhood: 'Greater Fifth Ward',
        img: 'https://i.imgur.com/JpDkbho.png',
        website: 'https://meowwolf.com/visit/houston/tickets',
        blurb: 'Radio Tave invites you to explore mind-expanding installations created by local Houston-area artists in collaboration with Meow Wolf’s visionary team.',
        description: ['Mystery', 'Creative', 'Full Bar']
    },
    {
        name: 'Toyota Center',
        category: 'attraction',
        subcategory: ['basketball'],
        badges: ['paid parking', 'alcohol available', 'live music'],
        coordinates: [29.75072566656762, -95.36205637080953],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/frk2ADY.png',
        website: 'https://www.toyotacenter.com',
        blurb: 'Toyota Center is an indoor arena located in Houston, Texas, United States. It is named after the Japanese automobile manufacturer Toyota.',
        description: ['Home of the Rockets', 'Arena Concerts', 'Reserved Seating']
    },
    {
        name: 'Houston Zoo',
        category: 'attraction',
        subcategory: ['zoo'],
        badges: ['photogenic'],
        coordinates: [29.712357766627584, -95.39194493955178],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/B6WvSwH.png',
        website: 'https://www.houstonzoo.org',
        blurb: 'Visitors can see 6,000+ animals in natural, habitat-style exhibits & watch daily care & feedings.',
        description: ['Giraffes', 'Tigers', 'Flamingos']
    },
    {
        name: 'Punch Line Houston',
        category: 'attraction',
        subcategory: ['comedy'],
        badges: ['alcohol available'],
        coordinates: [29.753678669519708, -95.3638775798053],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/lhRlNnI.png',
        website: 'https://www.punchlinehtx.com',
        blurb: 'Comedy club restaurant & bar.',
        description: ['International Comedians', 'Full Bar', 'Full Restaurant']
    },
    {
        name: 'NRG Stadium',
        category: 'attraction',
        subcategory: ['football'],
        badges: ['paid parking', 'alcohol available', 'live music'],
        coordinates: [29.684656629326128, -95.41077177682311],
        neighborhood: 'Astrodome Area',
        img: 'https://i.imgur.com/54hw9Jj.png',
        website: 'https://www.nrgpark.com/nrg-stadium/',
        blurb: 'Huge arena with a retractable roof hosting Houston Texans football games, rodeos, concerts & more.',
        description: ['Home of the Texans', 'Arena Concerts', 'Houston Rodeo']
    },
    {
        name: 'The Hobby Center',
        category: 'attraction',
        subcategory: ['comedy'],
        badges: ['paid parking', 'alcohol available', 'live music'],
        coordinates: [29.76164086726989, -95.36966571708332],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/SsQ4U3d.png',
        website: 'https://www.thehobbycenter.org',
        blurb: 'Modern spot with 2 theaters, a 3-story grand lobby with French styling & views of the city skyline.',
        description: ['downtown', 'proximity to Buffalo Bayou park', 'promiximity to bars']
    },
    {
        name: 'Fort Bend County Epicenter',
        category: 'attraction',
        subcategory: ['volleyball'],
        coordinates: [29.529567473389704, -95.81565532813188],
        neighborhood: 'Rosenberg',
        img: 'https://i.imgur.com/SKazz0N.png',
        website: 'https://thefortbendepicenter.com',
        blurb: 'The Fort Bend Epicenter is a 230,000 square foot multi-purpose arena and event space in the Houston suburb of Rosenberg, Texas. It is the home venue of LOVB Houston in LOVB Pro.',
        description: ['LOBV Volleyball', 'Concerts', 'Events']
    },
    {
        name: 'Texas Renaissance Faire',
        category: 'attraction',
        subcategory: ['faire'],
        badges: ['paid parking', 'alcohol available', 'photogenic'],
        coordinates: [30.255270127662044, -95.83879707491013],
        neighborhood: 'Todd Mission',
        img: 'https://i.imgur.com/VMlrtJn.png',
        website: 'https://www.texrenfest.com',
        blurb: "The Texas Renaissance Festival is a magical place for family fun and entertainment. Try your skills at the archery, axe throwing or Jacob's ladder.",
        description: ['Oct, November', 'Food & Shows', 'Campgrounds']
    },
    {
        name: 'Houston Rodeo',
        category: 'attraction',
        subcategory: ['rodeo'],
        badges: ['paid parking', 'alcohol available', 'photogenic'],
        coordinates: [29.6836988786707, -95.40936936833688],
        neighborhood: 'Astrodome Area',
        img: 'https://i.imgur.com/2plC7Cq.png',
        website: 'https://www.rodeohouston.com',
        blurb: "The Houston Livestock Show and Rodeo promotes agriculture by hosting an annual, family-friendly experience that educates and entertains the public, supports Texas youth, showcases Western heritage and provides year-round educational support within the community.",
        description: ['March Only', 'Cookout & Carnival', 'Livestock Show & Concerts']
    },
    {
        name: 'Puttery',
        category: 'attraction',
        subcategory: ['golf'],
        badges: ['alcohol available'],
        coordinates: [29.76797232796585, -95.37673048898021],
        neighborhood: 'Washington',
        img: 'https://i.imgur.com/5CBxBnX.png',
        website: 'https://www.puttery.com/locations/houston/',
        blurb: 'Trendy venue featuring a modern take on mini-golf, with auto-scoring technology, plus cocktails.',
        description: ['Full bar', 'Fun themes', 'Food']
    },
    {
        name: 'Jones Hall',
        category: 'attraction',
        subcategory: ['comedy'],
        badges: ['alcohol available'],
        coordinates: [29.76086967801885, -95.36499374068993],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/rjLRnUE.png',
        website: 'https://houstonsymphony.org',
        blurb: 'Grand, historic performing arts facility specializing in symphonies & other musical events.',
        description: ['Concerts', 'Upscale', 'Downtown located']
    },
    {
        name: 'Miller Outdoor Theatre',
        category: 'attraction',
        subcategory: ['comedy'],
        coordinates: [29.7191320417625, -95.3887510071658],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/2ykX8jK.png',
        website: 'https://www.milleroutdoortheatre.com',
        blurb: 'Outdoor spot featuring an 8-month season of free live shows including dance, music & theater.',
        description: ['Live performances', 'Lawn seating', 'Free events']
    },
    // Photo Opp
    {
        name: 'White Oak Bayou Rails Bridge',
        category: 'photo',
        badges: ['photogenic'],
        coordinates: [29.765619728541605, -95.35796023407394],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/ALfMgCP.png',
        website: 'https://www.google.com/search?client=opera-gx&hs=Fno&sca_esv=5c6211a02afc286c&sxsrf=AHTn8zpvW9EBOf8Uht14p2vaqEXfQCFLSQ:1746803461175&q=MKT+-+White+Oak+Bayou+Rails+To+Trails+Bridge&source=lnms&fbs=ABzOT_ByvNd_aIaDo5kB7Bu3gQZnW56Me--q0mBVqLHrHhEw6G4xZFB1KEALaTNfNtnq0rXvIBnNYNPUIf5ymOOWjHB5NY-5Vr64dkNpB_qYTCfuOVhNSogDEL4nMuyaU5XsE8PELbRxGePzyc7ngdUL82daXTL6Z9ym_KNaUQtqskndKR8U7axXY2J_uKnRIy6CmbGoavmBkmic5Yx6otCESUdfi017msLfUsyc7_c92iR9GPYqPfs&sa=X&ved=2ahUKEwii167-1ZaNAxVN48kDHc1sHbUQ0pQJegQIEBAB&biw=1879&bih=903&dpr=1',
        blurb: 'Downtown bridge connecting White Oak Bayou to University of Houston - Downtown',
        description: ['Bridge', 'Skyline', 'Trains']
    },
    {
        name: 'Jensen Dr Bridge',
        category: 'photo',
        badges: ['photogenic'],
        coordinates: [29.762263900993382, -95.3432496098287],
        neighborhood: 'EaDo',
        img: 'https://i.imgur.com/qQk0pwv.png',
        website: 'https://www.google.com/maps/place/21+Jensen+Dr,+Houston,+TX+77020/@29.7622732,-95.3434291,21z/data=!4m14!1m8!3m7!1s0x8640beda9e0bc645:0x8d87786ad1610df3!2s21+Jensen+Dr,+Houston,+TX+77020!3b1!8m2!3d29.7623399!4d-95.3432106!10e5!3m4!1s0x8640beda9e0bc645:0x8d87786ad1610df3!8m2!3d29.7623399!4d-95.3432106?entry=ttu&g_ep=EgoyMDI1MDUxMy4xIKXMDSoASAFQAw%3D%3D',
        blurb: 'Bridge with walking path with view of downtown facing West.',
        description: ['Bridge', 'Skyline', 'Facing Sunset']
    },
    {
        name: 'Sabine Steet Bridge',
        category: 'photo',
        badges: ['photogenic'],
        coordinates: [29.761352254832435, -95.37538291297814],
        neighborhood: 'Fourth Ward',
        img: 'https://i.imgur.com/0ahaHqu.png',
        website: 'https://www.google.com/maps?sca_esv=44cd9e4f38d377fc&output=search&q=sabine+street+bridge&source=lnms&fbs=ABzOT_CWdhQLP1FcmU5B0fn3xuWpA-dk4wpBWOGsoR7DG5zJBki0xbyJIUgVJnlXKXyPv8he7HXOZVM8kHbfynE2Ypquo56n7U2nAL0vrOqeAOfrlYXe1xunnz1eSS41n4gVF3_hz3Q8OLDfM2Z5CpZ7e3i4U4f5fD2HWym3iSkCqAWISV5wqh8ujVhWgTETM8q2vE32tdDEFRoZmcVK8BTi0w_6zRNfZg&entry=mc&ved=1t:200715&ictx=111',
        blurb: 'Bridge with walking path with close up view of downtown facing East.',
        description: ['Bridge', 'Night Photography', 'Romantic']
    },
    {
        name: 'Sanman Studios',
        category: 'photo',
        badges: ['photogenic'],
        coordinates: [29.7687404812231, -95.35635277490425],
        neighborhood: 'Downtown',
        img: 'https://i.imgur.com/UCAM2se.png',
        website: 'https://www.sanman.company/studio',
        blurb: 'Appointment-only photography and video studio with a selection of props and easy-to-use lighting.',
        description: ['Suite options', 'By the hour', 'Lighting provided']
    },
    // Museums
    {
        name: 'Museum of Fine Arts',
        category: 'museum',
        badges: ['photogenic'],
        coordinates: [29.725615154099373, -95.39044460816568],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/vMS2Ym2.png',
        website: 'https://www.mfah.org',
        blurb: 'The Museum of Fine Arts, Houston, is an art museum located in the Houston Museum District of Houston, Texas.',
        description: ['Seasonal Exhibits', 'Free Days', 'Memberships']
    },
    {
        name: 'Buffalo Soldiers National Museum',
        category: 'museum',
        coordinates: [29.73602561109945, -95.37810848467402],
        neighborhood: 'Midtown',
        img: 'https://i.imgur.com/1ec8GL4.png',
        website: 'https://buffalosoldiersmuseum.org',
        blurb: 'Research center dedicated to African-American soldiers with exhibits, workshops & reenactments.',
        description: ['Free Parking', 'Juneteenth Celebration', 'Vounteer Opportunities'],
    },
    {
        name: 'The Menil Collection',
        category: 'museum',
        neighborhood: 'Montrose',
        coordinates: [29.73716335081552, -95.39730798115231],
        img: 'https://i.imgur.com/yioxtrV.png',
        website: 'https://www.menil.org',
        blurb: 'Nearly 19,000 pieces of art & artifacts from the Paleolithic era to the present in a historic space.',
        description: ['Outdoor sculptures', 'Events', 'Party in the Park']
    },
    {
        name: 'Museum of African American Culture',
        category: 'museum',
        coordinates: [29.729603048703595, -95.38244010213161],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/Vh4qO5t.png',
        website: 'https://hmaac.org',
        blurb: 'African-American culture museum with art exhibits, film screenings & educational programs.',
        description: ['Films', 'Virtual Visits', 'Affordable Memberships']
    },
    {
        name: 'Museum of Natural Science',
        category: 'museum',
        badges: ['photogenic'],
        coordinates: [29.72209709585154, -95.38964460234973],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/rOgiZrK.png',
        website: 'https://www.hmns.org',
        blurb: 'Museum with dinosaur hall & other permanent exhibits, planetarium, IMAX theater & butterfly house.',
        description: ['Locatin in Hermann Park', 'Food available inside', 'Butterfly Exhibit']

    },
    {
        name: 'Contempory Arts Museum',
        category: 'museum',
        coordinates: [29.72636443216775, -95.39155574191462],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/2NBKQEd.png',
        website: 'https://www.google.com/url?url=http%3A%2F%2Fwww.camh.org%2F&sa=t&rct=j&source=maps&usg=AOvVaw1_kpZuT2Z-B6AS6lhD7jQI&ved=1i%3A0%2Ct%3A3443%2Ce%3A95%2Cp%3AuossaMzKD7u3wN4Pzae5cQ%3A1488',
        blurb: 'Long-standing museum with revolving exhibitions of modern art, as well as programs & talks.',
        description: ['Closed Mon, Tues', 'Free Parking', 'Various Exhibits']
    },
    {
        name: 'Holocaust Museum',
        category: 'museum',
        coordinates: [29.72521235463323, -95.38566367307256],
        neighborhood: 'Museum District',
        img: 'https://i.imgur.com/Nh5wxoF.png',
        website: 'https://hmh.org',
        blurb: 'This somber museum documents the Holocaust through exhibits of artifacts, photographs & film.',
        description: ['Events', 'Tours', 'Community Programs']
    },
    {
        name: 'Space Center Houston',
        category: 'museum',
        subcategory: ['space'],
        coordinates: [29.551968239892716, -95.09838780790388],
        neighborhood: 'Webster',
        img: 'https://i.imgur.com/PvhGiuy.png',
        website: 'https://spacecenter.org',
        blurb: 'Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.',
        description: ['Cafe', 'Restaurant', 'Rocketships']
    },
    // Daiquiris
    {
        name: 'Daiquiri Hut',
        category: 'daiquiris',
        badges: ['alcohol available'],
        coordinates: [29.847936844813724, -95.3140992410994],
        neighborhood: 'Houston Gardens',
        img: 'https://i.imgur.com/kfQTKNx.png',
        website: 'https://www.yelp.com/biz/daiquiri-hut-houston-6',
        blurb: 'Frozen daiquiri shop on Tidwell in Houston Gardens area.',
        description: ['Frozen Daiquiris', 'Many Flavors', 'Boozey Drinks']
    },
    {
        name: 'Creole Kitchen & Daiquiris',
        category: 'daiquiris',
        subcategory: ['chicken'],
        badges: ['NFC mobile payments', 'alcohol available'],
        coordinates: [29.700552878412847, -95.37651239280801],
        neighborhood: 'Astrodome Area',
        img: 'https://i.imgur.com/uVPNadQ.png',
        website: 'https://www.creole-kitchen.com',
        blurb: 'Casual restaurant and drive-thru serving elevated Creole comfort food for dine-in and take-out.',
        description: ['Fired Chicken', 'Boudin Eggrolls', 'Meat Pies']
    },
    {
        name: 'Orleans Daiquiri to Geaux',
        category: 'daiquiris',
        badges: ['NFC mobile payments', 'alcohol available', 'hookah'],
        coordinates: [29.87217686511884, -95.29997547656028],
        neighborhood: 'Houston Gardens',
        img: 'https://i.imgur.com/0RMh12U.png',
        website: 'https://www.instagram.com/nodaiquiritogeaux/?hl=en',
        blurb: 'Daiquiri shop with southern food plates.',
        description: ['Strong drinks', 'Good food', 'Hookah']
    }
]

export default locations;
